<template>
  <div class="mainBox">
    <div class="stuApply">
      <nav class="ots_header">{{ titleName }}</nav>
      <el-form inline ref="ruleForm" :model="ruleForm" :rules="formRules" :validate-on-rule-change="false">
        <!-- 基础信息部分 -->
        <section>
          <h4>基础信息</h4>
          <div>
            <!-- ----- 系统固定字段 ( 姓名, 证件类型, 证件号, 性别, 手机号 ) ----- -->
            <el-form-item label="姓名：">
              {{ ruleForm.realName }}
            </el-form-item>
            <el-form-item label="证件类型："> {{ getCardType }} </el-form-item>
            <el-form-item label="证件号：">
              {{ ruleForm.cardNo }}
            </el-form-item>
            <el-form-item label="性别：" prop="sex">
              <el-select
                v-model="ruleForm.sex"
                placeholder="请选择"
                :disabled="isCanEdit('sex') || !isCanEditByCardType"
              >
                <el-option label="男" :value="1"></el-option>
                <el-option label="女" :value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="手机号：" prop="phone" v-if="phoneAndEmailSet.isShowPhone">
              <el-input
                v-model="ruleForm.phone"
                placeholder="请输入"
                :disabled="isCanEdit('phone')"
              ></el-input>
            </el-form-item>
            <el-form-item label="邮箱：" prop="email" v-if="phoneAndEmailSet.isShowEmail">
              <el-input
                v-model="ruleForm.email"
                placeholder="请输入"
              ></el-input>
            </el-form-item>

            <!-- ----- 自定义字段 ----- -->
            <el-form-item
              :label="item.displayName + '：'"
              v-for="item in studentsInfo"
              :key="item.id"
              :class="{
                'upload-img': item.type == 'imageUpload',
                address: item.type == 'textarea',
              }"
              :prop="item.name"
            >
              <!-- (1) 基础信息, 自定义 - 下拉选项  -->
              <el-select
                v-model="ruleForm[item.name]"
                :placeholder="item.placeholder ? item.placeholder : '请选择'"
                v-if="
                  item.type == 'province' ||
                  item.type == 'select' ||
                  item.type == 'subject' ||
                  item.type == 'politicalStatus' ||
                  item.type == 'nation'
                "
                @change="$forceUpdate()"
                value-key="item"
                :disabled="isCanEdit(item.type)"
              >
                <el-option
                  :value="data.name"
                  v-for="(data, i) in item.valueVo"
                  :key="i"
                  :label="data.name"
                ></el-option>
              </el-select>

              <!-- (2) 基础信息, 自定义 - 日期 (YYYY-MM-DD) -->
              <el-date-picker
                v-model="ruleForm[item.name]"
                type="date"
                value-format="yyyy-MM-dd"
                v-if="item.type == 'date'"
                :placeholder="item.placeholder ? item.placeholder : '选择日期'"
                @input="$forceUpdate()"
              >
              </el-date-picker>

              <!-- (3) 基础信息, 自定义 - 日期时间 ( YYYY-MM-DD HH:mm:ss ) -->
              <el-date-picker
                v-model="ruleForm[item.name]"
                v-if="item.type == 'datetime'"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                @input="$forceUpdate()"
                :placeholder="
                  item.placeholder ? item.placeholder : '选择日期时间'
                "
              >
              </el-date-picker>

              <!-- (4) 基础信息, 自定义 - 单行文本 ( 文本格式 ) -->
              <el-input
                type="text"
                v-model.trim="ruleForm[item.name]"
                v-if="item.type == 'text' && item.dataType == 0"
                :placeholder="item.placeholder ? item.placeholder : '请输入'"
                @change="isUseRule($event, item.name)"
              ></el-input>

              <!-- (5) 基础信息, 自定义 - 单行文本 ( 数字格式 ) -->
              <el-input
                type="text"
                onkeyup="value=value.replace(/[^\d]/g,'')"
                v-model="ruleForm[item.name]"
                v-if="item.type == 'text' && item.dataType == 1"
                :placeholder="item.placeholder ? item.placeholder : '请输入'"
                @change="isUseRule($event, item.name)"
                auto-complete="off"
              ></el-input>

              <!-- (6) 基础信息, 自定义 - 多行文本 -->
              <el-input
                type="textarea"
                v-model="ruleForm[item.name]"
                v-if="item.type == 'textarea'"
                @change="isUseRule($event, item.name)"
                :placeholder="item.placeholder ? item.placeholder : '请输入'"
              ></el-input>

              <!-- (7) 自定义 - 出生日期 ( birthday ) -->
              <el-date-picker
                v-model="ruleForm[item.name]"
                type="date"
                value-format="yyyy-MM-dd"
                v-if="item.type == 'birthday'"
                :placeholder="
                  item.placeholder ? item.placeholder : '选择日期时间'
                "
                @input="$forceUpdate()"
                :disabled="isCanEdit('birthday')"
              >
              </el-date-picker>
              <!-- (8) 自定义 - 省市级联数据 ( provinceCity ) -->
              <el-cascader
                size="large"
                v-model="ruleForm[item.name]"
                :options="item.valueVo"
                :props="{ value: 'name', label: 'name', children: 'cityList' }"
                v-if="item.type == 'provinceCity'"
                @change="changeCity($event, item.name)"
              >
              </el-cascader>
            </el-form-item>
          </div>

          <div>
            <!-- 固定字段: 照片 -->
            <el-form-item label="照片：" class="center_img" prop="photo">
              <!-- 展示图片 -->
              <div class="img_style" v-if="ruleForm.photo">
                <img v-if="!ruleForm.photo" :src="getAvatarUrl" />
                <img :src="ruleForm.photo" class="avatar" />
              </div>
              <div v-else>
                <img :src="getAvatarUrl" />
              </div>
              <!-- 上传 -->
              <div class="avatarTips" :formData="formData">
                <!-- 上传按钮 -->
                <div class="productiontitlecss" v-if="(info.photoNums > 0 || this.upNums > 0)">
                  <el-button @click="clickiplodingimg" round>上传标准照</el-button>
                  <span class="productiontitle" @click="tipimg" v-if="planInfo.photoStandardNeed == 1"> 没有标准照 ？<span class="production">去制作></span></span>
                </div>
                <!-- 上传提示 -- (2024年1月13日) -->
                <p class="mb10"></p>

                <!-- 系统设置开启照片检测 显示 -->
                <!-- <div class="textloding" >
                </div> -->

                <!-- 照片上传次数 > 0 显示 -->
                <div class="textloding" >
                  <div v-if="basicsImageCheckFlag == 1">
                    <p class="col_grayQs" style="width: 560px;">
                      <span>为帮助您顺利通过人证核验，系统会对您上传的照片进行合规性检测，检测标准：</span>
                    </p>
                    <p class="col_grayQ" style="width: 560px;">
                      1、照片背景应为<span style="color: #FE5859;">蓝色/白色/红色</span>，不能出现其它颜色  <br />
                      2、照片需要清晰可识别身份，像素尺寸建议<span style="color: #FE5859;">480px*640px</span>，分辨率至少为<span style="color: #FE5859;">300dpi</span><br />
                      3、脸部无遮挡，头发不得遮挡脸部、眼睛、眉毛、耳朵或造成阴影，<span style="color: #FE5859;">露出五官</span><br />
                      4、头像居中，左右对称，头部和肩部端正且不能过大或过小，<span style="color: #FE5859;">占整个照片的比例约为2/3</span><br />
                      5、衣服颜色尽量与背景色<span style="color: #FE5859;">有明显区分</span>
                    </p>
                    <p class="col_grayQ">
                      <span>图片支持</span>
                      <span style="color: #fe5958"> {{ planInfo.photoFormat }} </span>
                      <span>格式，文件最大不超过</span>
                      <span style="color: #fe5958"> {{ planInfo.photoSize }} kb </span>
                      <span>。</span>
                    </p>
                  </div>
                  <div v-else-if="planInfo.photoUploadTimes > 0">
                    <!-- 上传次数 -->
                    <p class="col_grayQs">
                      <span>系统会对上传照片进行人脸核验，</span>
                      <span class="textcolor">{{ planInfo.photoUploadTimes }}次</span> 
                      <span>不通过将会影响您的此次报考，请严格按照以下要求上传照片：</span>
                    </p>
                    <!-- 上传描述 -->
                    <p class="col_grayQ" style="width: 80%">
                      <span v-if="planInfo.photoDescription">{{ planInfo.photoDescription }}</span>
                    </p>
                    <!-- 大小格式 -->
                    <p class="col_grayQ">
                      <span>图片支持</span>
                      <span style="color: #fe5958"> {{ planInfo.photoFormat }} </span>
                      <span>格式，文件最大不超过</span>
                      <span style="color: #fe5958"> {{ planInfo.photoSize }} kb </span>
                      <span>。</span>
                    </p>
                  </div>


                  <div v-if="planInfo.photoUploadTimes > 0">
                    <!-- 照片核验次数, 核验结果 -->
                    <p class="col_red" v-if="result !== ''">
                      <template v-if="!result">
                        <span v-if="upNums >= 1" class="text">人证核验不通过,请重新上传照片，您还剩{{ upNums  }}次核验机会。</span>
                        <span v-else class="text">人证核验不通过,您的人证核验机会已用尽，可联系院校老师进行处理，请继续填写其它报名信息。</span>
                        <br />
                      </template>
                      <template v-else>
                        <span class="text">人证核验通过</span>
                      </template>
                      <span class="text" v-if="savePhotoError">上传错误原因：{{ savePhotoError }}</span>
                    </p>
                    <!-- 照片上传失败处理 -->
                    <p v-else class="mt5 col_red">
                      <span>{{ photoStateText }}</span>
                      <span v-show="!info.photoNums && info.photoState === 0"> <span v-if="(typeof info.photoState) == 'number'">，</span> 您的人证核验机会已用尽，可联系院校老师进行处理，请继续填写其它报名信息。</span>
                      <br />
                      <span class="text" v-if="savePhotoError">上传错误原因：{{ savePhotoError }}</span>
                    </p>
                  </div>

                </div>

              </div>
            </el-form-item>
            <ots-custom-dialog
              :dialog.sync="paperDialog"
              title="照片裁剪"
              width="60%"
            >
              <template v-slot:content v-if="!this.option.img">
                <div class="titleimg">
                  <input
                    type="file"
                    @change="uploadImgs"
                    id="uploads"
                    class="inputImgs"
                    title=""
                  />
                  <el-button round class="clickbutton"> 添加照片 </el-button>
                  <p>点击添加图片，支持对 {{ planInfo.photoFormat }} 格式的图像进行裁剪</p>
                </div>
              </template>

              <template v-else v-slot:content>
                <div class="buttons">
                  <!-- <button @click="down">下载图片</button> -->
                  <div @click="rotateLeft" class="buttonmg">
                    <span><img src="../../../assets/img/icon-xuanzhuan.png" /></span>旋转
                  </div>

                  <div class="flright">
                    <div @click="minSize" class="minsize">
                      <p :class="{ active: activeBtn === 1 }" @click="activeBtn = 1">
                        一寸
                      </p>
                    </div>
                    <div @click="maxSize" class="maxSize">
                      <p :class="{ active: activeBtn === 2 }" @click="activeBtn = 2">
                        二寸
                      </p>
                    </div>
                  </div>

                </div>
                <div class="imgbg">
                  <div class="realtime-page">
                    <VueCropper
                      ref="cropper"
                      :img="option.img"
                      :fixed="false"
                      :canScale="true"
                      :autoCrop="true"
                      :canMove="true"
                      :canMoveBox="false"
                      :info="false"
                      :centerBox="false"
                      :fixedBox="true"
                      :autoCropWidth="option.autoCropWidth"
                      :autoCropHeight="option.autoCropHeight"
                    ></VueCropper>
                  </div>
                </div>
                <p class="p1-tis">
                  操作指导：按住鼠标左键可以对图片进行拖拽；滚动鼠标滑轮可以对图片进行缩放
                </p>
                <input
                  type="file"
                  @change="uploadImgs"
                  id="uploads"
                  class="inputCropper"
                />
                <el-button round class="yesbuttonone" style="margin-left: 15%">
                  重新选择照片
                </el-button>

                <el-button round @click="isPhotoUpload" class="yesbutton">确定使用</el-button>
              </template>
            </ots-custom-dialog>


            <ots-custom-dialog title="智能证件照" :dialog.sync="Reminderphoto">
              <template v-slot:content>
                <img
                  src="../../../assets/imglist/example.png"
                  class="exampleimg"
                />
                <el-button
                  round
                  class="yesbuttonone"
                  @click="pancelProduction"
                  style="margin-left: 25%"
                >
                  取消制作
                </el-button>
                <input
                  type="file"
                  @change="uploadAiImg"
                  id="uploads"
                  class="pancelimg"
                  title=""
                />
                <el-button round class="yesbutton">上传照片</el-button>
              </template>
            </ots-custom-dialog>




            <ots-custom-dialog :dialog.sync="paperDialogimg" title="制作证件照">
              <template v-slot:content>
                <div class="cropper-content">
                  <div class="cropperimg" style="text-align: center">
                    <div class="cropperimgwidth">
                      <div class="cropPicturewidth">
                        <img
                          v-if="cropPicture"
                          :src="cropPicture"
                          alt=""
                          class="original"
                        />
                        <img
                          class="original"
                          v-else
                          src="../../../assets/img/mseicon.png"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <p class="choosclothes">选择服装</p>
                <div class="overflowimg" v-if="ruleForm.sex == 1">
                  <div
                    v-for="(item, index) in listManImgs"
                    :key="index"
                    :class="{ listimg: item.colthes_ID === colthes_ID }"
                    @click="handleClickimg(item.colthes_ID)"
                  >
                    <img :src="item.img" />
                  </div>
                </div>
                <div class="overflowimg" v-else>
                  <div
                    v-for="(item, index) in listWoManImgs"
                    :key="index"
                    :class="{ listimg: item.colthes_ID === colthes_ID }"
                    @click="handleClickimg(item.colthes_ID)"
                  >
                    <img :src="item.img" />
                  </div>
                </div>
                <p class="prompt_p">
                  <img
                    class="prompticon"
                    src="../../../assets/img/prompt.png"
                    alt=""
                  />
                  <span class="promptfont">标准证件照确定使用后不含水印</span>
                </p>
                <input
                  type="file"
                  @change="uploadAiImg"
                  id="uploads"
                  class="advpancelimg"
                  title=""
                />
                <el-button round class="yesbuttonone" style="margin-left: 25%">
                  重新制作
                </el-button>
                <template v-if="cassnone">
                  <el-button round class="yesbutton" @click="checkFaceimgFn">
                    确定使用
                  </el-button>
                </template>
                <template v-else>
                  <el-button round class="yesbuttonnone"> 确定使用 </el-button>
                </template>
              </template>
            </ots-custom-dialog>
            <!-- 自定义 - 图片格式字段配置 -->
            <el-form-item
              :label="item.displayName + '：'"
              v-for="item in studentsPhotoInfo"
              :key="item.id"
              class="center_img"
              :prop="item.required == 1 ? item.name : ''"
            >
              <!-- 展示图片 -->
              <div class="img_style">
                <img
                  v-if="ruleForm[item.name]"
                  :src="ruleForm[item.name]"
                  @click="showBigImg(ruleForm[item.name], item.displayName)"
                />
                <img v-else :src="getAvatarUrl" class="avatar" />
              </div>
              <!-- 自定义图片上传处理 -->
              <div class="avatarTips">
                <el-upload
                  v-if="item.type == 'imageUpload'"
                  action=""
                  :data="{ '0': item.name }"
                  :show-file-list="false"
                  :before-upload="
                    (file) => {
                      return beforeAvatarUploadExt(
                        file,
                        item.fileBack,
                        item.filesize
                      );
                    }
                  "
                  :http-request="uploadImgExt"
                >
                  <el-button type="primary" round>点击上传</el-button>
                </el-upload>
                <p class="mb10"></p>
                <p class="col_grayQs">{{ item.remarks }}</p>
                <p class="col_grayQ">
                  照片支持
                  <span style="color: #fe5958">{{ item.fileBack }}</span>
                  格式，文件最大不超过
                  <span style="color: #fe5958">{{ item.filesize }} kb</span>。
                </p>
              </div>
            </el-form-item>
          </div>
        </section>

        <!-- 院校部分 -->
        <section>
          <h4>院校信息</h4>
          <div>
            <!-- 系统固定字段 - 院校 -->
            <el-form-item label="就读院校：" prop="schoolId">
              <el-select
                v-model="ruleForm.schoolId"
                placeholder="请选择"
                :disabled="isCanEdit('schoolId')"
              >
                <el-option
                  :label="item.name"
                  :value="item.id"
                  v-for="item in schoolList"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>

            <!-- 系统固定字段 - 教学点 -->
            <el-form-item :label="isStationName" prop="stationId">
              <el-select
                v-model="ruleForm.stationId"
                placeholder="请选择"
                :disabled="isCanEdit('stationId')"
                @change="changeStation"
              >
                <el-option
                  :label="item.name"
                  :value="item.id"
                  v-for="item in stationIdList"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>

            <!-- ----- 自定义字段 ----- -->
            <el-form-item
              :label="item.displayName + '：'"
              v-for="item in schoolInfo"
              :key="item.id"
              :class="{
                'upload-img': item.type == 'imageUpload',
                address: item.type == 'textarea',
              }"
              :prop="item.name"
            >
              <!-- (1) 自定义 - 下拉数据处理 ( 同时存在 "层次,专业" 时, 特殊配置 )  -->
              <el-select
                v-model="ruleForm[item.name]"
                :placeholder="item.placeholder ? item.placeholder : '请选择'"
                v-if="
                  item.type == 'level' ||
                  item.type == 'province' ||
                  item.type == 'select' ||
                  item.type == 'subject' ||
                  item.type == 'politicalStatus' ||
                  item.type == 'nation'
                "
                @change="(item.type == 'level' || item.type == 'subject') && LscPlugs? isLevelAndSubject(item.type, item.name, $event): $()"
                :disabled="(item.type == 'level' && gradationForbidden == 1) || (item.type == 'subject' && subjectForbidden == 1)"
                value-key="item" 
              >
                <el-option
                  :value="data.name"
                  v-for="(data, i) in item.valueVo"
                  :key="i"
                  :label="data.name"
                ></el-option>
              </el-select>

              <!-- (2) 自定义 - 日期格式 ( YYYY-MM-DD ) -->
              <el-date-picker
                v-model="ruleForm[item.name]"
                type="date"
                value-format="yyyy-MM-dd"
                v-if="item.type == 'date'"
                :placeholder="item.placeholder ? item.placeholder : '选择日期'"
                @input="$forceUpdate()"
              ></el-date-picker>

              <!-- (3) 自定义 - 日期时间格式 ( YYYY-MM-DD HH:mm:ss ) -->
              <el-date-picker
                v-model="ruleForm[item.name]"
                v-if="item.type == 'datetime'"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                @input="$forceUpdate()"
                :placeholder="
                  item.placeholder ? item.placeholder : '选择日期时间'
                "
              ></el-date-picker>

              <!-- (4) 自定义 - 单行文本 ( 无限制 )  -->
              <el-input
                type="text"
                v-model.trim="ruleForm[item.name]"
                v-if="item.type == 'text' && item.dataType == 0"
                :placeholder="item.placeholder ? item.placeholder : '请输入'"
                @change="isUseRule($event, item.name)"
              ></el-input>

              <!-- (5) 自定义 - 单行文本 ( 仅数字 ) -->
              <el-input
                type="text"
                onkeyup="value=value.replace(/[^\d]/g,'')"
                v-model="ruleForm[item.name]"
                v-if="item.type == 'text' && item.dataType == 1"
                :placeholder="item.placeholder ? item.placeholder : '请输入'"
                @change="isUseRule($event, item.name)"
                auto-complete="off"
              ></el-input>

              <!-- (6) 自定义 - 多文本输入框 -->
              <el-input
                type="textarea"
                v-model="ruleForm[item.name]"
                v-if="item.type == 'textarea'"
                style="width: 100%"
                @change="isUseRule($event, item.name)"
                :placeholder="item.placeholder ? item.placeholder : '请输入'"
              ></el-input>

              <!-- (7) 自定义 - 出生日期 ( birthday ) -->
              <el-date-picker
                v-model="ruleForm[item.name]"
                type="date"
                value-format="yyyy-MM-dd"
                v-if="item.type == 'birthday'"
                :placeholder="item.placeholder ? item.placeholder : '选择日期'"
                @input="$forceUpdate()"
              ></el-date-picker>

              <!-- (8) 自定义 - 省市级联 ( provinceCity ) -->
              <el-cascader
                size="large"
                v-model="ruleForm[item.name]"
                :options="item.valueVo"
                :props="{ value: 'name', label: 'name', children: 'cityList' }"
                v-if="item.type == 'provinceCity'"
                @change="changeCity($event, item.name)"
              ></el-cascader>
            </el-form-item>

            <!-- (9) 自定义字段, 图片类型 -->
            <el-form-item
              :label="item.displayName + '：'"
              v-for="item in schoolPhotoInfo"
              :key="item.id"
              class="center_img"
              :prop="item.name"
            >
              <div class="img_style">
                <img
                  v-if="ruleForm[item.name]"
                  :src="ruleForm[item.name]"
                  @click="showBigImg(ruleForm[item.name], item.displayName)"
                />
                <img v-else :src="getAvatarUrl" class="avatar" />
              </div>
              <div class="avatarTips">
                <el-upload
                  class="avatar-uploader dbi"
                  v-if="item.type == 'imageUpload'"
                  action=""
                  :data="{ '0': item.name }"
                  :show-file-list="false"
                  :before-upload="
                    (file) => {
                      return beforeAvatarUploadExt(
                        file,
                        item.fileBack,
                        item.filesize
                      );
                    }
                  "
                  :http-request="uploadImgExt"
                >
                  <el-button type="primary" round>点击上传</el-button>
                </el-upload>
                <p class="mb10"></p>
                <p class="col_grayQs">{{ item.remarks }}</p>
                <p class="col_grayQ">
                  照片支持
                  <span style="color: #fe5958">{{ item.fileBack }}</span>
                  格式，文件最大不超过
                  <span style="color: #fe5958">{{ item.filesize }} kb</span>。
                </p>
              </div>
            </el-form-item>
          </div>
        </section>

        <!-- 报考信息 -->
        <section>
          <h4>报考信息</h4>
          <div v-if="isUseTestSite">
            <el-form-item label="选择考点：" prop="placeId">
              <el-select v-model="ruleForm.placeId" placeholder="请选择">
                <el-option
                  :label="item.placeName"
                  :value="item.placeId"
                  v-for="item in placeListInfo"
                  :key="item.placeId"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div v-if="!isUseTestSite">
            <el-form-item
              :prop="isUseTestSite ? '' : 'checkList'"
              label="报考课程："
              v-if="signCoureCount == 0"
            >
              <el-checkbox-group v-model="ruleForm.checkList">
                <el-checkbox
                  :label="item.courseId"
                  v-for="item in courseList"
                  :key="item.courseId"
                  :disabled="courseDisabled || courseForbidden == 1"
                  >{{ item.courseName }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item
              :prop="isUseTestSite ? '' : 'checkList'"
              label="报考课程："
              v-else
            >
              <el-radio-group v-model="ruleForm.checkList">
                <el-radio
                  :label="item.courseId"
                  v-for="item in courseList"
                  :key="item.courseId"
                  :disabled="courseDisabled || courseForbidden == 1"
                  >{{ item.courseName }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>

          <div v-if="isUseTestSite">
            <el-form-item
              label="科目&时间："
              :prop="!isUseTestSite ? '' : 'courseSessionIds'"
              v-if="signCoureCount == 0"
            >
              <div v-for="(item, i) in courseList" :key="item.courseId">
                <div style="font-size: 14px; color: #45494d">
                  {{ item.courseName }}
                </div>
                <el-radio-group
                  v-model="ruleForm.courseSessionIds[i]"
                  v-if="isRefreshDom"
                >
                  <!-- :disabled="val.isUsable == 1" -->
                  <el-radio-button
                    @click.native="val.isUsable == 1 ? '' : changeIsActive(i, item.timeAndSessionId[index])"
                    :label="item.timeAndSessionId[index]"
                    :class="{ examType: true }"
                    v-for="(val, index) in item.timeAndSessionId"
                    :key="val.sessionId"
                    :disabled="val.isUsable == 1"
                  >
                    {{ val.sessionName }} 
                    <!-- {{ val.beginTime.slice(0, val.beginTime.length - 3) }} - {{ val.endTime.slice(val.beginTime.length - 8, val.beginTime.length - 3) }} -->
                    {{ val.stringBeginAndEndTime }}
                    剩余考位：{{val.leftSeatNumber}}
                  </el-radio-button>
                </el-radio-group>
              </div>
            </el-form-item>

            <el-form-item
              label="科目&时间："
              :prop="!isUseTestSite ? '' : 'courseSessionIds'"
              v-else
            >
              <div v-for="(item, i) in courseList" :key="item.courseId">
                <div style="font-size: 14px; color: #45494d">
                  {{ item.courseName }}
                </div>
                <el-radio-group
                  v-if="isRefreshDom"
                  v-model="ruleForm.courseSessionIds[i]"
                >
                  <el-radio-button
                    @click.native="val.isUsable == 1 ? '' : changeCourse(i, item.timeAndSessionId[index])"
                    :label="item.timeAndSessionId[index]"
                    :class="{ examType: true }"
                    v-for="(val, index) in item.timeAndSessionId"
                    :key="val.sessionId"
                    :disabled="val.isUsable == 1"
                  >
                    {{ val.beginTime }} -- {{ val.endTime }}
                  </el-radio-button>
                </el-radio-group>
              </div>
            </el-form-item>
            <!-- <el-form-item
              label="科目&场次："
              :prop="!isUseTestSite ? '' : 'courseSessionIds'"
            >
              <div v-for="(item, i) in courseList" :key="item.sessionId">
                <div style="font-size: 14px; color: #45494d">
                  {{ item.sessionName }} {{item.sessionBeginTime}} - {{item.sessionEndTime}}
                  预约人数：<span style="color: #FE5859;">{{item.signCount}} / {{item.allCount}}</span>
                </div>
                <el-radio-group
                  v-if="isRefreshDom"
                  v-model="ruleForm.courseSessionIds[i]"
                >
                  <el-radio-button
                    @click.native="changeIsActive_2(i, item.courseVoList[index])"
                    :label="item.courseVoList[index]"
                    :class="{ examType: true }"
                    v-for="(val, index) in item.courseVoList"
                    :key="val.courseId"
                    :disabled="val.isUsable == 1"
                  >
                    {{val.courseName}}
                  </el-radio-button>
                </el-radio-group>
              </div>
            </el-form-item> -->
          </div>

          <div v-if="optionalExam == 1">
            <el-form-item label="预约考试日期：" prop="schoolId">
              <el-select
                v-model="ruleForm.optionalExamDate"
                placeholder="请选择"
                class="timeClass"
                v-if="everyBodyLimitShow > 0"
              >
                <el-option
                  :label="
                    item.examDate +
                    ' 已预约' +
                    item.examCount +
                    '人可预约' +
                    item.leftCount +
                    '人'
                  "
                  :value="item.examDate"
                  v-for="item in examTime"
                  :key="item.examDate"
                ></el-option>
                
              </el-select>
              <el-select
                v-model="ruleForm.optionalExamDate"
                placeholder="请选择"
                class="timeClass"
                v-else
              >
                <el-option
                  :label="
                    item.examDate +
                    ' 已预约' +
                    item.examCount +
                    '人' 
                  "
                  :value="item.examDate"
                  v-for="item in examTime"
                  :key="item.examDate"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>

        </section>


        <!-- 免考信息 -->
        <section v-if="ExemptCourseList.length > 0">
          <h4>免考信息<span style="color: #FE5958; font-size: 14px;">（如符合免考条件可提交免考信息申请）</span></h4>
          <div>
            <el-form-item label="免考课程">
              <el-radio-group v-model="exemptCourseId">
                <el-radio label="">不申请免考</el-radio>
                <el-radio
                  :label="item.id"
                  v-for="item in ExemptCourseList"
                  :key="item.id"
                  >{{ item.name }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>

          <div v-if="exemptCourseId">
            <el-form-item>
              <span slot="label">
                <span style="color: #FE5958;">*</span>
                免考原因
              </span>
              <el-select v-model="exemptReasonId" placeholder="请选择">
                <el-option :label="item.reasonName" :value="item.reasonId" v-for="item in ExemptReasonList" :key="item.reasonId"></el-option>
              </el-select>
            </el-form-item>
            <p style="height: 36px; display: flex; margin-bottom: 30px;" v-if="exemptRemark">
              <span style="display: inline-block; padding-right: 16px; text-align: right; width: 120px; box-sizing: border-box; line-height: 36px;">上传说明：</span>
              <span style="display: inline-block; max-width: 960px;line-height: 36px;">{{ exemptRemark }}</span>
            </p>
          </div>

          <div v-if="exemptCourseId">
            <el-form-item>
              <span slot="label">
                材料证明网站
              </span>
              <el-input v-model="reasonProveText" maxlength="100" class="fileWebsite" placeholder="请录入学信网或相关证书查询网站链接"></el-input>
            </el-form-item>
          </div>

          <div v-if="exemptCourseId">
            <el-form-item >
              <span slot="label">
                <span style="color: #FE5958; display: inline-block; margin-top: 5px;">*</span>
                免考材料
              </span>
              <div style="display: flex; align-items: center;">
                <ots-upload-file v-model="ExemptForm.file" ref="OtsUploadFile" :httpRequest="handleFormData" style="margin-top: 8px; margin-right: 16px;"/>
                <span>可上传 JPG，JPEG，PNG，PDF 格式文件</span>
              </div>
              <el-upload
                class="upload-demo"
                action=""
                :on-remove="handleRemove"
                :on-change="handleSuccess"
                :file-list="ExemptFileList"
                :before-upload="beforeAvatarUpload_Exempt"
                :http-request="uploadImg_Exempt"
                list-type="picture"
                >
                <div slot="file" slot-scope="{file}">
                  <img class="el-upload-list__item-thumbnail" :src="file.fileext == 'pdf'? defaultUrl: file.url" alt="" style="cursor: pointer;">
                  <span class="el-upload-list__item-actions" style="cursor: pointer;">
                    <a class="el-upload-list__item-name"><i class="el-icon-document"></i></a>
                    <span class="el-upload-list__item-preview">
                      {{ file.name }}
                    </span>
                  </span>
                  <label class="el-upload-list__item-status-label">
                    <i class="el-icon-upload-success el-icon-check"></i>
                  </label>
                  <i class="el-icon-close" @click="handleRemove(file, ExemptFileList)"></i>
                </div>
              </el-upload>
            </el-form-item>
          </div>

        </section>

        <section v-if="studentFileInfo.length > 0">
          <h4>报名材料</h4>
          <div style="margin-bottom: 16px; display: flex; align-items: center;" v-for="(item, index) in studentFileInfo" :key="item.id">
            <span style="display: inline-block; width: 120px;">
              <span style="color: #FE5958; font-size: 14px;" v-if="item.required == 1">* </span>
              <span style="color: #FFFFFF; font-size: 14px;" v-else>* </span>
              {{ item.filename }}：
            </span>
            <el-upload
              style="display: inline-block;"
              class="upload-demo"
              action=""
              :before-upload="attachment_beforeAvatarUpload"
              :http-request="attachment_uploadImg"
              :on-change="attachment_handleSuccess"
              :limit="1"
              :file-list="attachment_FileList[index]"
              list-type="picture">
              <el-button size="small" type="primary" @click="attachmentIndex = index" v-if="!attachment_FileList[index] || attachment_FileList[index].length == 0">上传</el-button>
              <div slot="file" slot-scope="{file}">
                <img class="el-upload-list__item-thumbnail" :src="defaultUrl" alt="" v-if="file.fileext == 'pdf'">
                <img class="el-upload-list__item-thumbnail" :src="wordDefaultUrl" alt="" v-else-if="file.fileext == 'doc' || file.fileext == 'docx'">
                <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" v-else>


                <span class="el-upload-list__item-actions">
                  <a class="el-upload-list__item-name"><i class="el-icon-document"></i></a>
                  <span class="el-upload-list__item-preview">
                    {{ file.name }}
                  </span>
                </span>
                <label class="el-upload-list__item-status-label">
                  <i class="el-icon-upload-success el-icon-check"></i>
                </label>
                <i class="el-icon-close" @click="attachment_handleRemove(file)"></i>
              </div>
            </el-upload>
            <span style="margin-left: 16px;">
              <span>可上传</span>
              <span style="color: #FE5859;"> {{item.fileext}} </span> 
              <span>格式文件，最多不超过</span>
              <span style="color: #FE5859;"> {{item.filesize}} MB</span>
              <span v-if="item.fileRemark">，（{{ item.fileRemark }}）</span>
              <span>&nbsp;&nbsp;</span>
              <el-button type="text" v-if="item.sampleUrl" @click="showUrl(item.sampleUrl)">查看图例</el-button>
              <el-button type="text" v-if="item.templateUrl" @click="showUrl(item.templateUrl)">下载模板</el-button>
              </span>
          </div>
        </section>

        <el-form-item class="agreement">
          <el-checkbox v-model="checkeds">本人已确认提交报名信息真实无误且符合报名考试资格，后期因提交报名信息不真实、有误、不符合报名考试资格，导致的一切后果自行承担。</el-checkbox>
        </el-form-item>

      </el-form>
    </div>

    <stu-foot
      cancelText="取消"
      @cancel="cancel"
      confirmtext="提交报名信息"
      @confirm="UpdateRegistrationFN('ruleForm')"
      :confirmDisabled = "submitBtnFlag"
    ></stu-foot>

    <el-dialog
      title="报名须知"
      :visible.sync="centerDialogVisible"
      append-to-body
      width="960px"
      height="600px"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
    >
      <p v-html="signRemark"></p>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="centerDialogVisible = false"
          :disabled="isCountDownFinsh"
          >本人已认真阅读，同意报考 {{ getTimeText }}</el-button
        >
      </span>
    </el-dialog>


    <el-dialog
      :title="stataBigImgTitle"
      :visible.sync="isShowBigImg"
      append-to-body
      width="960px"
      height="600px"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      class="showBigImg"
    >
      <img :src="stataBigImg" alt="" />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="isShowBigImg = false" >关闭 {{ stataBigImgTitle }}</el-button>
      </span>
    </el-dialog>

    <!-- 上传标准照（照片裁剪） -->
    <ots-custom-dialog
      :dialog.sync="photoUploadDialog"
      title="照片上传信息确认"
      width="60%"
    >
      <template v-slot:content>
        <p>
          <span>您好，每人只有</span>
          <span style="color: #fe5958"> {{planInfo.photoUploadTimes}} </span>
          <span>次上传机会；目前您还剩</span>
          <span style="color: #fe5958"> {{info.photoNums}} </span>
          <span>次，请您选择合格照片，谨慎上传！如果照片上传机会用完则关闭上传入口，将导致您无法完成报名！</span>
        </p>
        <div style="margin-top: 24px; display: flex; justify-content: right;">
          <el-button type="primary" plain @click="photoUploadDialog = false" round>取消</el-button>
          <el-button type="primary" @click="isPhotoUploadSure" round>确定</el-button>

        </div>
      </template>
    </ots-custom-dialog>
  
    <!-- 制作标准照（智能证件照） -->
    <ots-custom-dialog
      :dialog.sync="photoUploadDialogAI"
      title="照片上传信息确认"
      width="60%"
    >
      <template v-slot:content>
        <p>
          <span>您好，每人只有</span>
          <span style="color: #fe5958"> {{planInfo.photoUploadTimes}} </span>
          <span>次上传机会；目前您还剩</span>
          <span style="color: #fe5958"> {{info.photoNums}} </span>
          <span>次，请您选择合格照片，谨慎上传！如果照片上传机会用完则关闭上传入口，将导致您无法完成报名！</span>
        </p>
        <div style="margin-top: 24px; display: flex; justify-content: right;">
          <el-button type="primary" plain @click="photoUploadDialogAI = false" round>取消</el-button>
          <el-button type="primary" @click="checkFaceimgFnSure" round>确定</el-button>
        </div>
      </template>
    </ots-custom-dialog>

    <!-- 提交报名验证码确认 -->
    <ots-custom-dialog
      :dialog.sync="phoneDialog"
      title="提交报名验证码确认"
      width="40%"
    >
      <template v-slot:content>
        <div>
          <!-- <p class="mb16"> 已发送短信验证码至 {{passPhone}} 的手机，请您查收验证码！</p> -->
          <el-input v-model="phoneCode" placeholder="请输入验证码"></el-input> 
          <el-button type="text" class="ml8" @click="getPhoneCode" v-if="getPhoneCodeNumber == 0">获取验证码</el-button>
          <el-button type="text" disabled v-else-if="phoneCountDown > 0" class="ml8">{{phoneCountDown}} s</el-button>
          <el-button type="text" class="ml8" @click="getPhoneCode" v-else>重新发送</el-button>
        </div>
      </template>
      <template v-slot:footer>
        <div style="margin-top: 24px; display: flex; justify-content: right;">
          <el-button type="primary" size="small" plain @click="phoneDialog = false;submitBtnFlag = false;" round>返回</el-button>
          <el-button type="primary" size="small" @click="phoneUpdateRegistration" round>确定报名</el-button>
        </div>
      </template>
    </ots-custom-dialog>

    <ots-custom-dialog
      :dialog.sync="changePhotoUploadDialog"
      title="照片合规检测"
      width="60%"
    >
      <template v-slot:content>
        <p>
          <span style="font-size: 16px;">{{imageCheckForm.imageCheckMsg}}</span>
        </p>
        <div style="margin-top: 24px; display: flex; justify-content: right;">
          <el-button type="primary" plain @click="changePhotoUploadDialog = false" round>替换照片</el-button>
          <el-button type="primary" v-if="imageCheckForm.imageCheckCount > imageCheckForm.imageCheckMaxCount" @click="function() { photoUploadDialog = true; changePhotoUploadDialog = false}" round>仍要上传</el-button>

        </div>
      </template>
    </ots-custom-dialog>


  </div>
</template>
<script>
import { UpdateRegistration, selectOneSignUp, uploadExtSet, getSignDateCount, uploadStationFilesAPI, studentFilesUploadAPI, planFileSetListAPI, studentFilesListAPI, studentFilesDeleteAPI,getFieldModifyScopeByPlanIdAPI } from "@/http/modules/custom";
import { getQueryAllSchool } from "@/http/modules/school";
import { getQueryAllStation } from "@/http/modules/station";
import { getPlaceList, courseListTime } from "@/http/modules/baseSet/examSite";
import { checkPhone,checkEmail } from "../../../common/verify";
import stuFoot from "@/views/student/components/stuFoot";
import { mapState,mapGetters } from "vuex";
import { getLSCRelation, selectPlugs, getLevelListByRelationFN,} from "@/http/modules/baseSet/majorCourse";
import { VueCropper } from "vue-cropper";
import { getPlanCourseExemptScopeAPI, getExemptReasonListAPI, uploadExemptFileAPI, getStudentCourseExemptListAPI } from '@/http/modules/baseSet/course'
import { checkStudentSignPlanExclusiveAPI } from "@/http/modules/student/batch";

export default {
  name: "stuApply",
  components: {
    stuFoot,
    VueCropper,
    //ImageUpload,
  },
  data() {
    return {
      attachment_FileList: [],
      attachmentIndex: 0,
      photoUploadDialog: false,
      photoUploadDialogAI: false,
      planInfo: {},
      examTime: {}, //考试时间是否可选
      needStandardPhoto: "",
      cassnone: true,
      colthes_ID: "",
      base64File: "",
      Reminderphoto: false, //智能证件照
      errorimg: "",
      imgResult: "",
      cropPicture: "", //第三方转换后的照片
      uploadType: "",
      photoId: "",
      resbase: "",
      courseRadioId: "",
      paperDialog: false,
      paperDialogimg: false,
      downImg: "",
      option: {
        img: "",
        outputSize: 1,
        outputType: "png",
        autoCropWidth: 200,
        autoCropHeight: 300,
        fixedBox: true,
      },
      savePhotoError: "",
      watchPlace: 0,
      isShowBigImg: false,
      stataBigImg: "",
      stataBigImgTitle: "",
      isStationName: "",
      centerDialogVisible: true,
      countDown: 5,
      // countDown: 1,
      ruleForm: {
        optionalExamDate: "",
        checkList: [],
        courseSessionIds: [],
      },
      optionalExam:'',
      regionFiledList: [],
      formData: { maxNum: "" },
      titleName: "",
      stationId: [],
      schoolList: [],
      subjectId: [],
      stationIdList: [],
      courseList: [],
      checkeds: "",
      signRemark: "",
      cardNo: "",
      info: {},
      upNums: "",
      upNum: "",
      result: "",
      photo: "",
      type: "",
      url: "",
      flag: "",
      basicsMaptext: "",
      listWoManImgs: [
        {
          img: require("@/assets/imglist/noReplacement.jpg"),
          colthes_ID: "",
        },
        {
          img: require("@/assets/imglist/6.png"),
          colthes_ID: "woman_1",
        },
        {
          img: require("@/assets/imglist/7.png"),
          colthes_ID: "woman_2",
        },
        {
          img: require("@/assets/imglist/8.png"),
          colthes_ID: "woman_3",
        },
        {
          img: require("@/assets/imglist/9.png"),
          colthes_ID: "woman_4",
        },
        {
          img: require("@/assets/imglist/10.png"),
          colthes_ID: "woman_5",
        },
      ],
      listManImgs: [
        {
          img: require("@/assets/imglist/noReplacement.jpg"),
          colthes_ID: "",
        },
        {
          img: require("@/assets/imglist/1.png"),
          colthes_ID: "man_1",
        },
        {
          img: require("@/assets/imglist/2.png"),
          colthes_ID: "man_2",
        },
        {
          img: require("@/assets/imglist/3.png"),
          colthes_ID: "man_3",
        },
        {
          img: require("@/assets/imglist/4.png"),
          colthes_ID: "man_4",
        },
        {
          img: require("@/assets/imglist/5.png"),
          colthes_ID: "man_5",
        },
      ],
      rules: {
        realName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        sex: [{ required: true, message: "请输入性别", trigger: "blur" }],
        phone: [
          {
            required: true,
            message: "请输入正确的手机号",
            trigger: "blur",
            validator: checkPhone,
          },
        ],
        cardType: [
          { required: true, message: "请选择证件类型", trigger: "blur" },
        ],
        cardNo: [{ required: true, message: "请输入证件号", trigger: "blur" }],
        schoolId: [{ required: true, message: "请选择学校", trigger: "blur" }],
        stationId: [
          { required: true, message: "请选择函数站", trigger: "blur" },
        ],
        checkList: [
          { required: true, message: "请选择课程", trigger: "change" },
        ],
        courseSessionIds: [
          { required: true, message: "请选择科目&时间", trigger: "change" },
        ],
        address: [
          {
            required: true,
            message: "由于疫情防控要求，请填写居住地详细地址",
            trigger: "blur",
          },
        ],
        photo: [{ required: true, message: "请上传照片", trigger: "blur" }],
        placeId: [{ required: true, message: "请选择考点", trigger: "change" }],
      },
      isCanEditByCardType: true,
      studentsInfo: [],
      schoolInfo: [],
      studentsPhotoInfo: [],
      schoolPhotoInfo: [],
      birthday: "",
      customForm: {},
      customRules: {},
      provinceCity: [],
      subjectName: "",
      levelName: "",
      basicsMapImgRules: {},
      LscJson: "",
      LscPlugs: false,
      courseListConst: [],
      courseDisabled: false,
      isUseTestSite: false,
      placeListInfo: [],
      filterCourseList: [],
      courseTimeList: [],
      sessionIdList: [],
      isRefreshDom: true,
      timeAndSessionIdDtoList: [],
      isClickTheCourseList: false,
      isUseEditSessionIds: [],
      isUseCourseAndSessionIds: [],
      isCanToast: false,
      imgInfo: {
        one: {
          width: 295,
          height: 413,
        },
        two: {
          width: 413,
          height: 579,
        },
      },
      imgFlag: "one",
      activeBtn: 1,
      signCoureCount: "",
      needAudit: "",
      everyBodyLimitShow: '',
      photoVerifyId: "",

      // 2024年5月13日
      courseForbidden: "0",
      gradationForbidden: "0",
      subjectForbidden: "0",

      // 报名是否发短信
      smsCheckForSign: 0,
      phoneDialog: false,
      phoneCode: "",
      getPhoneCodeNumber: 0,
      phoneCountDown: 0,
      params: {},

      // 免考课程
      ExemptCourseList: [],
      exemptCourseId: "",
      ExemptReasonList: [],
      exemptReasonId: "",
      exemptReasonName: "",
      reasonProveText: "",
      ExemptForm: {
        file: "",
      },
      ExemptFileList: [],
      defaultUrl: require("@/assets/img/PDFIcon.png"),
      wordDefaultUrl: require("@/assets/img/WORDIcon.jpg"),
      changePhotoUploadDialog: false,
      imageCheckForm: {},
      basicsImageCheckFlag: 0,
      exemptRemark: "",

      // 报名附件
      studentFileInfo: [],

      //提交按钮是否禁用
      submitBtnFlag : false,

      phoneAndEmailSet: {},
    };
  },
  computed: {
    ...mapState(["studentType"]),
    ...mapGetters(['getCardTypeName']),

    passPhone() {
      let ruleForm = JSON.parse(JSON.stringify(this.ruleForm));
      if (ruleForm.phone) {
        return ruleForm.phone.slice(0, 3) + "****" + ruleForm.phone.slice(7, 11);
      } else {
        return "";
      }
    },

    isShowMessage() {
      if (this.watchPlace > 2 && this.LscPlugs) {
        return true;
      } else {
        return false;
      }
    },
    confirmDisabled() {
      let { flag } = this;
      if (flag === 0) {
        return false;
      } else if (flag === 1) {
        return false;
      } else if (flag === 3) {
        return false;
      } else if (flag === null) {
        return false;
      }
      return true;
    },
    getCardType() {
      // const cardType = ["身份证", "护照", "士官证", "港澳台身份证"];
      // return cardType[this.ruleForm.cardType - 1];
      return this.getCardTypeName(this.ruleForm.cardType);
    },
    isCountDownFinsh() {
      return this.countDown > 1;
    },
    getTimeText() {
      let { countDown } = this;
      return countDown > 0 ? `(${countDown}s)` : "";
    },
    hideimg() {},
    getAvatarUrl() {
      return require("../../../assets/img/auto-photo.jpg");
    },
    photoStateText() {
      if (typeof this.info.photoState == "number") {
        const textList = ["系统审核不通过", "系统审核通过", "人工通过"];
        return textList[this.info.photoState];
      }
    },
    formRules() {
      let tmpStationName = this.isStationName && this.isStationName.length > 1 ? this.isStationName.slice(0, -1) : '函授站';
      let rules = {
        realName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        sex: [{ required: true, message: "请输入性别", trigger: "blur" }],
        cardType: [
          { required: true, message: "请选择证件类型", trigger: "blur" },
        ],
        cardNo: [{ required: true, message: "请输入证件号", trigger: "blur" }],
        schoolId: [{ required: true, message: "请选择学校", trigger: "blur" }],
        stationId: [
          { required: true, message: `请选择${tmpStationName}`, trigger: "blur" },
        ],
        checkList: [
          { required: true, message: "请选择课程", trigger: "change" },
        ],
        courseSessionIds: [
          { required: true, message: "请选择科目&时间", trigger: "change" },
        ],
        address: [
          {
            required: true,
            message: "由于疫情防控要求，请填写居住地详细地址",
            trigger: "blur",
          },
        ],
        photo: [{ required: true, message: "请上传照片", trigger: "blur" }],
        placeId: [{ required: true, message: "请选择考点", trigger: "change" }],
      }
      if (this.phoneAndEmailSet.isMastPhone) {
        rules.phone = [
          {
            required: true,
            message: "请输入正确的手机号",
            trigger: "blur",
            validator: checkPhone,
          }
        ]
      }
      if (this.phoneAndEmailSet.isMastEmail) {
        rules.email = [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { message: "邮箱格式错误", trigger: "blur", type: "email" },
        ]
      }
      return {
        ...rules,
        ...this.customRules
      };
    }
  },
  watch: {
    getCardType: function (val) {
      if (val == "身份证") {
        this.isCanEditByCardType = false;
        this.setDataByCard();
      }
    },
    "ruleForm.placeId": "autoSetListTime",
    exemptReasonId: function(val) {
      this.ExemptReasonList.map(e => {
        if (e.reasonId == val) {
          this.exemptReasonName = e.reasonName;
          this.exemptRemark = e.remark;
        }
      })
    },
    courseList: function (val) {
      for (let key in val) {
        this.ruleForm.courseSessionIds[key] = {};
        this.timeAndSessionIdDtoList[key] = {};
        if (val[key].timeAndSessionId) {
          val[key].timeAndSessionId.map((e) => {
            this.isUseCourseAndSessionIds.map((item) => {
              if (
                item.courseId == e.courseId &&
                item.sessionId == e.sessionId
              ) {
                this.ruleForm.courseSessionIds[key] = e;
                this.timeAndSessionIdDtoList[key] = e;
              }
            });
          });
        }
      }
      this.ruleForm.courseSessionIds = this.isClickTheCourseList ? []: this.timeAndSessionIdDtoList;    
    },
  },

  created() {
    this.$store.dispatch('fetchCardTypeList');
    this.initFileData();
  },

  mounted() {
    this.initData();
    this.getInfo();
    this.initCountDown();
    this.getConfigData();
    this.getSignDateCountFn();
    // 获取免考课程 && 免考原因
    this.getExemptCourseList();
    this.getSystemName();
  },
  methods: {
    async getSystemName(){
      let params = window.localStorage.getItem("tenant");
      this.$api.system.getSystemNameFN({ tenant: params }).then((res) => {
        let phoneObj = res.data.baseDefList.find((item) => item.fieldName == "phone");
        if(phoneObj) {
          this.phoneAndEmailSet.isMastPhone = phoneObj.required == 1 ? true : false;
          this.phoneAndEmailSet.isShowPhone = phoneObj.showInPage == 1 ? true : false;
        }
        let emailObj = res.data.baseDefList.find((item) => item.fieldName == "email");
        if(emailObj) {
          this.phoneAndEmailSet.isMastEmail = emailObj.required == 1 ? true : false;
          this.phoneAndEmailSet.isShowEmail = emailObj.showInPage == 1 ? true : false;
        }
      })
      .catch((err) => {
        return;
      });
    },
    /**************************************
     * @param { 报名材料 => 初始化数据 }
     *************************************/
    async initFileData() {
      const { code: configCode, data: configData } = await planFileSetListAPI({planId: this.getCurrentGlobalPlanId()})
      if (configCode && configData.length > 0) {
        configData.forEach(item=>{
          item.filesize = item.filesize / 1024;
        })
        this.studentFileInfo = configData;
        configData.map((e,i) => {
          this.attachment_FileList[i] = [];
        })
      } else {
        return false;
      }
      const { code, data } = await studentFilesListAPI({planId: this.getCurrentGlobalPlanId()})
      if (code && data.length > 0) {
        this.attachment_FileList = [];
        configData.map((item, key) => {
          data.map((e,i)=>{
            if (e.planFileSetId == item.id) {
              e.name = e.filename;
              this.attachment_FileList[key] = [];
              this.attachment_FileList[key].push(e);
            }
          })
        })
      }
    },


    /**************************************
     * @param { 报名材料 => 附件上传前：格式校验 }
     *************************************/
    attachment_beforeAvatarUpload(fileData) {
      let config = this.studentFileInfo[this.attachmentIndex];
      let ImgRules = config.fileext.toLowerCase().split(",")
      // if (ImgRules.includes("jpg")) {
      //   ImgRules.push("jpeg");
      // }
      let type = fileData.name.substring(fileData.name.lastIndexOf(".") + 1).toLowerCase();
      // const isJPG = ImgRules.indexOf(type) !== -1;
      const isJPG = ImgRules.includes(type);
      const isLt30kb = fileData.size / 1024 / 1024  < config.filesize;

      if (!isJPG && !isLt30kb) {
        this.$message.error(`${config.filename}上传只能是 ${config.fileext} 格式，且大小不能超过 ${config.filesize} MB! `);
      } else if (!isJPG) {
        this.$message.error(`${config.filename}上传只能是 ${config.fileext} 格式!`);
      } else if (!isLt30kb) {
        this.$message.error(`${config.filename}上传大小不能超过 ${config.filesize} MB!`);
      }
      return isJPG && isLt30kb;
    },

    /**************************************
     * @param { 报名材料：附件上传前：文件变动 }
     *************************************/
    attachment_handleSuccess(file, fileList) {
      this.attachment_FileList[this.attachmentIndex] = fileList;
    },

    /**************************************
     * @param { 报名材料：删除 }
     *************************************/
    attachment_handleRemove(file, fileList) {
      if (!file.id) {
        return ;
      }
      let id = file.id;
      studentFilesDeleteAPI({id}).then(res => {
        if (res.code) {
          this.$message.success(res.data);
        }
        this.initFileData();
      });
    },

    /**************************************
     * @param { 附件上前：文件处理 }
     *************************************/
    attachment_uploadImg(data) {

      // (1) 文件处理
      let that = this;
      let fileData = data.file;
      let reader = new FileReader();
      reader.readAsDataURL(fileData);
      reader.onload = function (e) {
        if (data.file && that.studentFileInfo[that.attachmentIndex].id) {
          const fd = new FormData();
          fd.append("file", data.file);
          fd.append("planFileSetId", that.studentFileInfo[that.attachmentIndex].id);
          fd.append("planId", that.getCurrentGlobalPlanId());
          studentFilesUploadAPI(fd).then(({code, data})=>{
            if (code) {
              that.initFileData();
            }
          })
        }
      };
    },

    // 获取免考课程 && 免考原因 
    async getExemptCourseList() {
      let planId = this.getCurrentGlobalPlanId();
      const { data: ExemptCourseList } = await getPlanCourseExemptScopeAPI({planId});
      this.ExemptCourseList = ExemptCourseList;
      const { data: ExemptReasonList } = await getExemptReasonListAPI();
      this.ExemptReasonList = ExemptReasonList;

      let studentUserId = JSON.parse(localStorage.getItem("userInfo")).id;
      const { data: ExemptRes } = await getStudentCourseExemptListAPI({ planId, studentUserId });
      if (ExemptRes) {
        this.exemptCourseId = ExemptRes[0].courseId;
        this.exemptReasonId = ExemptRes[0].reasonId;
        this.exemptReasonName = ExemptRes[0].reasonName;
        this.reasonProveText = ExemptRes[0].reasonProveText;
        this.ExemptFileList = ExemptRes[0].fileList;
        this.ExemptFileList.map(e=>{
          e.name = e.filename;
        })
      }
    },
    // 免考材料上传
    async handleFormData(val) {
      this.ExemptForm.file = val.file;
      const fd = new FormData();
      for (let item in this.ExemptForm) {
        fd.append(item, this.ExemptForm[item]);
      }

      const { code, data } = await uploadExemptFileAPI(fd);
      if (code) {
        data.name = data.fileName;
        this.ExemptFileList.push(data);
      }
    },

    // 移除免考材料
    handleRemove(file, fileList) {
      this.ExemptFileList = fileList.filter(function(e){
        return e.id != file.id;
      });
    },

    // 上传免考材料
    handleSuccess(file, fileList) {
      this.ExemptFileList = fileList;
    },

    // 免考材料校验
    beforeAvatarUpload_Exempt(fileData) {
      let ImgRules = ["jpg", "jpeg", "png", "pdf"]
      let type = fileData.name.substring(fileData.name.lastIndexOf(".") + 1);
      const isJPG = ImgRules.indexOf(type) !== -1;
      if(!isJPG) {
        this.$message.error(`免考材料只能是 "PDF", "JPG", "JPEG", "PNG" 格式!`);
      }
      return isJPG
    },

    // 免考材料处理
    uploadImg_Exempt(data) {
      let that = this;
      let fileData = data.file;
      let reader = new FileReader();
      reader.readAsDataURL(fileData);
      reader.onload = function (e) {
        if (e.currentTarget.result) {
          that.ExemptFileList.map((item, index)=> {
            if (item.name == data.file.name) {
              that.ExemptFileList[index].url = e.currentTarget.result;
            }
          })
        }
      };
    },

    // 获取验证码
    async getPhoneCode() {
      let params = {
        planId: this.planId,
        phone: this.ruleForm.phone,
        email: this.ruleForm.email,
      }
      const { data, code} = await this.$api.system.sendSmsForSign(params);
      if (code == 1) {
        this.$message.success(data);
        this.GetCode();
        this.getPhoneCodeNumber++;
        // window.localStorage.setItem("getPhoneCodeNumber", this.getPhoneCodeNumber);
      }
    },

    // 由短信校验触发的报名
    async phoneUpdateRegistration() {
      if(!this.phoneCode) {
        this.$message.error("请输入报名验证码！");
        return;
      }
      let params = {...this.params};
      params.smsCheckCode = this.phoneCode;
      const data = await UpdateRegistration(params);
      if(data.code == 1){
        setTimeout(()=>{
          this.$message.success("报名成功");
          this.$router.push({
            path: "/stuHome/stuExamine",
          });
        },1000) 
      }
    },

    // 倒计时存入缓存,防止刷新重置
    GetCode() {
      let endMsRes = new Date().getTime() + 60000
      localStorage.setItem("phoneEndTime", JSON.stringify(endMsRes))
      this.codeCountDown(endMsRes)
      this.phoneCountDown = 60;
    },

    // 倒计时计算,清除缓存和定时器
    codeCountDown(endMsRes) {
      this.phoneCountDown = Math.ceil((endMsRes - new Date().getTime()) / 1000);
      let time = setTimeout(() => {
        this.phoneCountDown--;
        if (this.phoneCountDown < 1) {
          localStorage.removeItem("phoneEndTime");
          clearTimeout(time);
        } else {
          this.codeCountDown(endMsRes);
        }
      }, 1000);
    },




    // initPhoneCountDown() {
    //   if (this.phoneCountDown <= 0) {
    //     clearTimeout(this.phoneTimer);
    //     return;
    //   }
    //   if (this.phoneTimer) {
    //     clearTimeout(this.phoneTimer);
    //   }
    //   this.phoneCountDown = this.phoneCountDown - 1;
    //   this.phoneTimer = setTimeout(this.initPhoneCountDown, 1000);
    // },

    getSignDateCountFn() {
      getSignDateCount({ planId: this.getCurrentGlobalPlanId() }).then((res) => {
          if (res.data != 1 && res.data) {
            this.examTime = res.data;
            this.everyBodyLimitShow = this.examTime[0].everyBodyLimit
          }
      });
    },
    handleClickimg(colthes) {
      let base64Fileimg = this.option.aiImg.replace(/data.+?;base64,/, "");
      this.colthes_ID = colthes;
      let formData = new FormData();
      if (this.photoId) {
        formData.append("photoId", this.photoId);
      } else {
        formData.append("base64Img", base64Fileimg);
      }
      formData.append("clothesID", this.colthes_ID);

      formData.append("planId", this.getCurrentGlobalPlanId());
      formData.append("cardNo", this.ruleForm.cardNo);
      formData.append("stuId", this.ruleForm.id);
      formData.append("uploadType", "2");
      this.$api.applyManage.standardPhotoByPreview(formData).then((res) => {
        if (res.code == 1) {
          this.cropPicture = res.data.photoUrl;
          this.photoId = res.data.photoId;
        }
      });
    },

    // 上传标准照    
    clickiplodingimg() {
      if (this.ruleForm.sex === null) {
        this.$alert("请填写性别信息！", "修改提示", {
          confirmButtonText: "确定",
          type: "warning",
        });
      } else {
        this.paperDialog = true;
      }
    },







    minSize() {
      this.imgFlag = "one";
    },
    maxSize() {
      this.imgFlag = "two";
    },
    rotateLeft() {
      this.$refs.cropper.rotateLeft();
    },


    // 校验图片格式
    photoCheck(file) {
      
    },

    /**
     * @param { 上传标准照 }
     */
    uploadImgs(e) {
      const file = e.target.files[0];

      // 2024年1月17日
      if (!this.beforeAvatarUpload(file)) {
        return false;
      }

      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        alert("图片类型必须是.gif,jpeg,jpg,png中的一种");
        return false;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        let data;
        if (typeof e.target.result === "object") {
          // 把Array Buffer转化为blob 如果是base64不需要
          data = window.URL.createObjectURL(new Blob([e.target.result]));
        } else {
          data = e.target.result;
        }
        this.option.img = data;
      };
      const blob = reader.readAsArrayBuffer(file);
    },


    /**
     * @param { 照片 => 制作 => 上传照片 }
     */
    uploadAiImg(e) {
      const file = e.target.files[0];
      // 2024年1月17日
      if (!this.beforeAvatarUpload(file)) {
        return false;
      }

      this.paperDialogimg = true;
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        alert("图片类型必须是.gif,jpeg,jpg,png中的一种");
        return false;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        let data;
        if (typeof e.target.result === "object") {
          // 把Array Buffer转化为blob 如果是base64不需要
          data = window.URL.createObjectURL(new Blob([e.target.result]));
        } else {
          data = e.target.result;
        }
        this.option.aiImg = data;
        this.cropPicture = data;
        let base64Fileimg = this.option.aiImg.replace(/data.+?;base64,/, "");
        let formData = new FormData();
        formData.append("clothesID", this.colthes_ID);
        formData.append("base64Img", base64Fileimg);
        formData.append("planId", this.getCurrentGlobalPlanId());
        formData.append("cardNo", this.ruleForm.cardNo);
        formData.append("stuId", this.ruleForm.id);
        formData.append("uploadType", "2");
        this.$api.applyManage.standardPhotoByPreview(formData).then((res) => {
          if (res.code == 1) {
            this.cropPicture = res.data.photoUrl;
            this.photoId = res.data.photoId;
            this.cassnone = true;
          } else {
            this.cassnone = false;
          }
        });
      };
      reader.readAsDataURL(file);
    },
    pancelProduction() {
      this.Reminderphoto = false;
    },
    tipimg() {
      if (this.ruleForm.sex === null) {
        this.$alert("请填写性别信息！", "修改提示", {
          confirmButtonText: "确定",
          type: "warning",
        });
      } else {
        this.Reminderphoto = true;
      }
    },

    // 智能证件照 ==> 执行
    checkFaceimgFnSure() {
      let formData = new FormData();
      formData.append("cardNo", this.ruleForm.cardNo);
      formData.append("photoId", this.photoId);
      formData.append("clothesID", this.colthes_ID);
      formData.append("stuId", this.ruleForm.id);
      formData.append("stuName", this.ruleForm.realName);
      formData.append("type", this.ruleForm.cardType);
      formData.append("planId", this.getCurrentGlobalPlanId());
      formData.append("uploadType", "2");
      this.$api.applyManage.savePhoto(formData).then((res) => {
        if (res.code == 0) {
          this.savePhotoError = res.error.msg;
        } 

        this.photoVerifyId = res.data.photoVerifyId ? res.data.photoVerifyId: '';

        let upNum = 0;
        let maxNum = 0;
        let url = "";
        if (res.error !== null) {
          upNum = res.error.upNum ? res.error.upNum : 0;
          maxNum = res.error.maxNum ? res.error.maxNum : 0;
          url = res.error.url;
          this.result = res.error.result === undefined ? "" : res.error.result;
        } else {
          upNum = res.data.upNum;
          maxNum = res.data.maxNum;
          this.result = res.data.result === undefined ? "" : res.data.result;
          url = res.data.url;
        }
        if (url) {
          this.url = url;
          this.ruleForm.photo = url;
        }
        this.upNum = upNum;
        this.upNums = maxNum - upNum;
        this.Reminderphoto = false;
        this.paperDialogimg = false;
        this.photoUploadDialogAI = false;
        this.getInfo();
        // if (this.upNums == 0) {
        //   this.getInfo();
        // }
        if (!res.data.url) {
          this.cassnone = false;
        }
      });
    },

    // 智能证件照 => 开启提示弹窗
    checkFaceimgFn() {
      this.photoUploadDialogAI = true;
    },
    
    // 上传标准照 => 添加照片 => 确认使用 ==> 开启提示弹窗
    isPhotoUpload(fileData) {

      if (this.basicsImageCheckFlag !== 1) {
        this.photoUploadDialog = true;
        return;
      }

      this.$refs.cropper.getCropData( data => {
        const newCanvas = document.createElement("canvas");
        const context = newCanvas.getContext("2d");
        const Img = new Image();
        Img.src = data;
        Img.onload = async () => {
          const ImageInfo = this.imgInfo[this.imgFlag];
          newCanvas.width = ImageInfo.width;
          newCanvas.height = ImageInfo.height;
          context.drawImage(Img, 0, 0, newCanvas.width, newCanvas.height);
          this.imgResult = newCanvas.toDataURL("jpg", 0.5);
          data = this.imgResult;
          let database = data.lastIndexOf(",");
          this.resbase = data.substring(database + 1, data.length);
          let checkForm = new FormData();
          checkForm.append("base64Img", this.resbase);
          checkForm.append("cardNo", this.ruleForm.cardNo);
          checkForm.append("planId", this.getCurrentGlobalPlanId());
          checkForm.append("stuId", this.ruleForm.id);

          const { data: checkInfo } = await this.$api.applyManage.checkPhoto(checkForm);
          this.imageCheckForm = { ...checkInfo };
          
          if (checkInfo.imageCheckCode == 1) {
            this.$message.success("照片检测通过！");
            this.photoUploadDialog = true;
          } else {
            this.changePhotoUploadDialog = true;
          }
        };
      })
    },

    // 上传标准照 => 执行
    isPhotoUploadSure() {
      this.$refs.cropper.getCropData((data) => {
        const newCanvas = document.createElement("canvas");
        const context = newCanvas.getContext("2d");
        const Img = new Image();
        Img.src = data;
        Img.onload = async () => {
          const ImageInfo = this.imgInfo[this.imgFlag];
          newCanvas.width = ImageInfo.width;
          newCanvas.height = ImageInfo.height;
          context.drawImage(Img, 0, 0, newCanvas.width, newCanvas.height);
          this.imgResult = newCanvas.toDataURL("jpg", 0.5);
          data = this.imgResult;
          let database = data.lastIndexOf(",");
          this.resbase = data.substring(database + 1, data.length);
          let loc = JSON.parse(localStorage.getItem("userInfo"));
          let formData = new FormData();
          formData.append("base64Img", this.resbase);
          formData.append("planId", this.getCurrentGlobalPlanId());
          formData.append("cardNo", this.ruleForm.cardNo);
          formData.append("stuName", this.ruleForm.realName);
          formData.append("stuId", this.ruleForm.id);
          formData.append("type", this.ruleForm.cardType);
          formData.append("uploadType", "1");

          if (this.basicsImageCheckFlag == 1) {
            formData.append("imageCheckCode", this.imageCheckForm.imageCheckCode);
            formData.append("imageCheckMsg", this.imageCheckForm.imageCheckMsg);
          }


          this.$api.applyManage.savePhoto(formData).then((res) => {
            if (res.code == 0) {
              this.savePhotoError = res.error.msg;
              this.paperDialog = false;
            } else {
              this.savePhotoError = "";
              this.paperDialog = false;
              this.ruleForm.photo = res.data.url;
              this.photoVerifyId = res.data.photoVerifyId;
            }
            let upNum = 0;
            let maxNum = 0;
            let url = "";
            if (res.error !== null) {
              upNum = res.error.upNum ? res.error.upNum : 0;
              maxNum = res.error.maxNum ? res.error.maxNum : 0;
              url = res.error.url;
              this.result = res.error.result === undefined ? "" : res.error.result;
            } else {
              upNum = res.data.upNum;
              maxNum = res.data.maxNum;
              this.result = res.data.result === undefined ? "" : res.data.result;
              url = res.data.url;
            }
            if (url) {
              this.url = url;
              this.ruleForm.photo = url;
            }
            this.upNum = upNum;
            this.upNums = maxNum - upNum;
            this.Reminderphoto = false;
            this.paperDialogimg = false;
            this.photoUploadDialog = false;
            this.getInfo();

            // if (this.upNums == 0) {
            //   this.getInfo();
            // }

          });
        };
      });
    },

    changeStation(val) {
      if (!this.planId || !val) {
        return false;
      } else {
        if (this.isUseTestSite) {
          getPlaceList({ planId: this.planId, stationId: val }).then((res) => {
            if (res.code == 1) {
              this.placeListInfo = res.data;
              if (res.data.length == 1) {
                this.ruleForm.placeId = res.data[0].placeId;
              } else {
                this.ruleForm.placeId = "";
              }
            }
          });
        } else {
          return false;
        }
      }
    },

    async autoSetListTime(val) {
      if (this.isUseTestSite) {
        this.ruleForm.courseSessionIds = [];
        if (val && this.planId) {
          this.getListTime();
        } else if (!val) {
          this.courseList = [];
        }
      }
    },
    changeCourse(e, i) {
      this.ruleForm.courseSessionIds.forEach((item, index) => {
        if (index !== i) {
          this.$set(this.ruleForm.courseSessionIds, index, {});
        } else {
          this.$set(this.ruleForm.courseSessionIds, index, e);
        }
      });
    },
    changeIsActive(i, e) {
      if (this.isUseEditSessionIds.indexOf(e.sessionId) != -1) {
        for (let key in this.isUseEditSessionIds) {
          if (this.isUseEditSessionIds[key] == e.sessionId) {
            delete this.isUseEditSessionIds[key];
          }
        }
      }
      this.isClickTheCourseList = true;
      if (
        this.ruleForm.courseSessionIds[i] &&
        e.sessionId == this.ruleForm.courseSessionIds[i].sessionId
      ) {
        this.ruleForm.courseSessionIds[i] = {};
        this.isRefreshDom = false;
        this.$nextTick(() => {
          this.isRefreshDom = true;
        });
      }
    },
    changeIsActive_2(i, e) {
      if (
        this.ruleForm.courseSessionIds[i] &&
        e.courseId == this.ruleForm.courseSessionIds[i].courseId
      ) {
        this.ruleForm.courseSessionIds[i] = {};
        this.isRefreshDom = false;
        this.$nextTick(() => {
          this.isRefreshDom = true;
        });
      }
      return;

      if (this.isUseEditSessionIds.indexOf(e.sessionId) != -1) {
        for (let key in this.isUseEditSessionIds) {
          if (this.isUseEditSessionIds[key] == e.sessionId) {
            delete this.isUseEditSessionIds[key];
          }
        }
      }
      this.isClickTheCourseList = true;
      if (
        this.ruleForm.courseSessionIds[i] &&
        e.courseId == this.ruleForm.courseSessionIds[i].courseId
      ) {
        this.ruleForm.courseSessionIds[i] = {};
        this.isRefreshDom = false;
        this.$nextTick(() => {
          this.isRefreshDom = true;
        });
      }
    },
    // changeIsActive_2

    initData() {
      this.mixin_setUserExtInfo().then((res) => {
          res.data.map((e) => {
            if (e.title == 1 && e.type != "imageUpload") {
              this.studentsInfo.push(e);
            } else if (e.title == 1 && e.type == "imageUpload") {
              this.studentsPhotoInfo.push(e);
            } else if (e.title == 2 && e.type != "imageUpload") {
              this.schoolInfo.push(e);
            } else if (e.title == 2 && e.type == "imageUpload") {
              this.schoolPhotoInfo.push(e);
            }
            if (e.type == "birthday") {
              this.birthday = e.name;
            } else if (e.type == "level") {
              this.levelName = e.name;
            } else if (e.type == "subject") {
              this.subjectName = e.name;
            }
          });
          this.ruleForm = Object.assign({}, this.ruleForm, res.customForm);
          this.customRules = res.customRules;
          //this.formRules = Object.assign(this.formRules, res.customRules);
          return this.$api.applyManage.getCurrentPlan({
            planId: this.getCurrentGlobalPlanId(),
          })
        })
        .then((res) => {

          // 当前批次信息 -- (2024年1月13日)
          this.planInfo = res.data;
          if (!this.planInfo.photoDescription) {
            this.planInfo.photoDescription = "必须是报考人本人真实免冠照片，不许带眼镜，照片应清晰可识别身份，过于模糊的照片无法上报成功。";
          }

          this.isUseTestSite = res.data.optionalSession == 1;
          this.ruleForm.optionalSession = res.data.optionalSession;
          this.planId = res.data.id;
          this.titleName = res.data.name;
          this.signRemark = res.data.signRemark;
          this.countDown = res.data.signRemarkTime;
          this.getCourse();
          this.selectOneSignUpFN();
          this.ruleForm.courseSessionIds = [];
          this.signCoureCount = res.data.signCoureCount;
          this.needAudit = res.data.needAudit;
          this.optionalExam  =res.data.optionalExamDate
          return selectPlugs({ levelType: "level", subjectType: "subject" });
        })
        .then((res) => {
          if (res.data == "true") {
            this.LscPlugs = true;
            this.resetLscFn();
          } else {
            this.LscPlugs = false;
            return false;
          }
        });

      getQueryAllStation({ state: 1 }).then((res) => {
        this.stationIdList = res.data;
      });
      getQueryAllSchool({ state: 1 }).then((res) => {
        if (res.code) {
          this.schoolList = res.data;
        }
      });

      getFieldModifyScopeByPlanIdAPI({planId: this.getCurrentGlobalPlanId()}).then(res=>{
        if(res.code == 1 && res.data.length>0){
          const allowedFields = res.data.filter(item => item.allowModify === 0).map(item => item.fieldCode);
          this.regionFiledList = allowedFields.join(',');
          this.gradationForbidden = allowedFields.includes("Level") ? "1" : "0";
          this.subjectForbidden = allowedFields.includes("Subject") ? "1" : "0";
          this.courseForbidden = allowedFields.includes("CourseId") ? "1" : "0";
        }
      });

    },

    getListTime() {
      this.watchPlace++;
      let params = {
        placeId: this.ruleForm.placeId,
        planId: this.planId,
      };
      if (!params.placeId) {
        return false;
      }

      courseListTime(params).then((res) => {
        if (res.code == 1) {
          if (!this.LscPlugs) {
            this.courseList = res.data;
          } else {
            let notSetCourse = [];
            let courseListIds = [];
            this.courseList = [];
            this.filterCourseList.map((e) => {
              courseListIds.push(e.courseId);
            });

            res.data.map((e) => {
              if (courseListIds.indexOf(e.courseId) != -1) {
                this.courseList.push(e);
              } else {
                notSetCourse.push(e.courseName);
              }
              this.courseList = [...this.newCourseList(this.courseList)];
            });

            if (notSetCourse.length > 0 && this.isShowMessage) {
              if (this.isCanToast) {
                let that = this;
                this.isCanToast = false;
                this.$message.warning(
                  `课程“${notSetCourse.join("，")}”未在“专业课程设置”中配置`
                );
                setTimeout(() => {
                  that.isCanToast = true;
                }, 2000);
              }
            }
          }
        }
      });
    },

    // uploadAireturn(){
    //   this.paperDialogimg = true;
    //   this.Reminderphoto = false;
    // },

    uploadreturn() {
      this.paperDialog = true;
      this.lopopupuimg = false;
    },

    resetLscFn() {
      getLSCRelation({
        planId: this.getCurrentGlobalPlanId(),
      }).then((res) => {
        this.schoolInfo.map((e) => {
          if (e.name == this.levelName) {
            getLevelListByRelationFN().then((res) => {
              e.valueVo = res.data;
            });
          }
        });
        this.LscJson = res.data;
        this.schoolInfo.map((e) => {
          if (e.type == "subject") {
            e.valueVo = [];
          }
        });
        this.courseList = [];
        if (this.ruleForm[this.levelName]) {
          res.data.map((e) => {
            if (this.ruleForm[this.levelName] == e.levelName) {
              e.subjectVoList.map((m) => {
                let s = { id: m.subjectId, name: m.subjectName };
                this.schoolInfo.map((e) => {
                  if (e.type == "subject") {
                    e.valueVo.push(s);
                    e.valueVo = [...this.newLscList(e.valueVo)];
                  }
                });
                if (this.ruleForm[this.subjectName]) {
                  if (m.subjectName == this.ruleForm[this.subjectName]) {
                    m.courseVoList.map((isin) => {
                      if (this.courseListConst.indexOf(isin.courseId) != -1) {
                        this.courseList.push(isin);
                      }
                    });
                  }
                } else {
                  m.courseVoList.map((isin) => {
                    if (this.courseListConst.indexOf(isin.courseId) != -1) {
                      this.courseList.push(isin);
                    }
                  });
                }
              });
            }
          });
        } else {
          res.data.map((e) => {
            e.subjectVoList.map((m) => {
              let s = { id: m.subjectId, name: m.subjectName };
              this.schoolInfo.map((e) => {
                if (e.type == "subject") {
                  e.valueVo.push(s);
                  e.valueVo = [...this.newLscList(e.valueVo)];
                }
              });
              if (this.ruleForm[this.subjectName]) {
                if (m.subjectName == this.ruleForm[this.subjectName]) {
                  m.courseVoList.map((isin) => {
                    if (this.courseListConst.indexOf(isin.courseId) != -1) {
                      this.courseList.push(isin);
                    }
                  });
                }
              } else {
                m.courseVoList.map((isin) => {
                  if (this.courseListConst.indexOf(isin.courseId) != -1) {
                    this.courseList.push(isin);
                  }
                });
              }
            });
          });
        }
        this.courseList = [...this.newCourseList(this.courseList)];
        this.filterCourseList = [...this.newCourseList(this.courseList)];
        this.isHaveCourseList();

        if (this.isUseTestSite) {
          this.getListTime();
        }
      });
    },

    isLevelAndSubject(type, name, value) {
      this.ruleForm.checkList = [];
      this.courseList = [];
      this.LscJson.map((e) => {
        if (type == "level" && value == e.levelName) {
          this.ruleForm[this.subjectName] = "";
          this.schoolInfo.map((item) => {
            if (item.type == "subject") {
              item.valueVo = [];
              e.subjectVoList.map((sub) => {
                let s = { id: sub.subjectId, name: sub.subjectName };
                item.valueVo.push(s);
              });
            }
          });
          e.subjectVoList.map((cou) => {
            cou.courseVoList.map((isin) => {
              if (this.courseListConst.indexOf(isin.courseId) != -1) {
                this.courseList.push(isin);
              }
            });
            this.courseList = [...this.newCourseList(this.courseList)];
            this.filterCourseList = [...this.newCourseList(this.courseList)];
          });
        }
        if (type == "subject") {
          if (this.ruleForm[this.levelName]) {
            if (e.levelName == this.ruleForm[this.levelName]) {
              e.subjectVoList.map((m) => {
                if (m.subjectName == value) {
                  m.courseVoList.map((isin) => {
                    if (this.courseListConst.indexOf(isin.courseId) != -1) {
                      this.courseList.push(isin);
                    }
                  });
                  this.courseList = [...this.newCourseList(this.courseList)];
                  this.filterCourseList = [
                    ...this.newCourseList(this.courseList),
                  ];
                }
              });
            }
          } else {
            e.subjectVoList.map((m) => {
              if (m.subjectName == value) {
                m.courseVoList.map((isin) => {
                  if (this.courseListConst.indexOf(isin.courseId) != -1) {
                    this.courseList.push(isin);
                  }
                });
                this.courseList = [...this.newCourseList(this.courseList)];
                this.filterCourseList = [
                  ...this.newCourseList(this.courseList),
                ];
              }
            });
          }
        }
      });
      if (this.ruleForm.placeId) {
        this.getListTime();
      }
      this.isHaveCourseList();
      this.$forceUpdate();
    },

    isHaveCourseList() {
      if (this.courseList.length == 0) {
        this.$message.warning(
          "该层次专业对应课程未配置，请联系相关人员进行配置！"
        );
      } else if (this.courseList.length == 1) {
        // this.ruleForm.checkList.push(this.courseList[0].courseId);

        if (this.signCoureCount == 0) {
          this.ruleForm.checkList.push(this.courseList[0].courseId);
        } else {
          this.ruleForm.checkList = this.courseList[0].courseId
        }

        this.courseDisabled = true;
      } else if (this.courseList.length > 1) {
        this.courseDisabled = false;
      }


    },

    newLscList(arr) {
      let map = new Map();
      for (let item of arr) {
        if (!map.has(item.id)) {
          map.set(item.id, item);
        }
      }
      return [...map.values()];
    },

    newCourseList(arr) {
      let map = new Map();
      for (let item of arr) {
        if (!map.has(item.courseId)) {
          map.set(item.courseId, item);
        }
      }
      return [...map.values()];
    },

    showBigImg(url, title) {
      this.stataBigImgTitle = title;
      this.stataBigImg = url;
      this.isShowBigImg = true;
    },

    isUseRule(val1, val2) {
      // this.rules[val2][0].required = true;
      // if ( val1 ) {
      //   this.rules[val2][0].required = true;
      // } else {
      //   this.rules[val2][0].required = false;
      // }
    },

    beforeAvatarUploadExt(fileData, fileType, fileSize) {
      let ImgRules = fileType.split(",");
      let key = "";
      for (let i = 0; i < ImgRules.length; i++) {
        if (ImgRules[i] == "jpg") {
          key = i;
        }
      }
      ImgRules[key] = "jpeg";
      let type = fileData.type.split("/")[1];
      const isJPG = ImgRules.indexOf(type) !== -1;
      const isLt30kb = fileData.size / 1024 < fileSize;
      if (!isJPG) {
        this.$message.error(`上传图片只能是 ${fileType} 格式!`);
      }
      if (!isLt30kb) {
        this.$message.error(`上传图片大小不能超过 ${fileSize} kb!`);
      }
      return isJPG && isLt30kb;
    },

    changeCity(e, item) {
      if (this.provinceCity.includes(item)) {
        return false;
      } else {
        this.provinceCity.push(item);
      }
    },

    uploadImgExt(data) {
      let attr = data.data[0];
      let fileData = data.file;
      let fileTypeLast = data.file.name.lastIndexOf(".");
      let fileType = "";
      if (fileTypeLast !== -1) {
        fileType = data.file.name.slice(fileTypeLast + 1).toLowerCase();
      } else {
        return false;
      }
      this.upLoadSstateCustom(fileData, fileType, attr);
    },

    upLoadSstateCustom(fileData, fileType, attr) {
      let formData = new FormData();
      formData.append("upfile", fileData);
      formData.append("fileType", fileType);
      formData.append("planId", this.getCurrentGlobalPlanId());
      uploadExtSet(formData).then((res) => {
        this.ruleForm[attr] = res.data;
      });
    },

    getInfo() {
      let planId = this.getCurrentGlobalPlanId();
      this.$api.stuApply.selectByOne({ planId }).then((res) => {
        if (res.code === 1) {
          this.info = res.data;
        }
      });
    },

    selectOneSignUpFN() {
      let planId = this.planId;
      let loc = JSON.parse(localStorage.getItem("userInfo"));
      let params = {
        stuIds: loc.id,
        planId: planId,
      };
      selectOneSignUp(params).then((res) => {
        if (!res.data.photoUrl) {
          this.info.photoState = "";
        } 

        // this.courseForbidden = res.data.courseForbidden;
        // this.gradationForbidden = res.data.gradationForbidden;
        // this.subjectForbidden = res.data.subjectForbidden;
        this.isUseCourseAndSessionIds = res.data.timeAndSessionIdDtoList? res.data.timeAndSessionIdDtoList.map((e) => { return { courseId: e.courseId, sessionId: e.sessionId } }): [];

        if (res.data.timeAndSessionIdDtoList) {
          res.data.timeAndSessionIdDtoList.map((e, i) => {
            if (e.isUsable == 1) {
              res.data.timeAndSessionIdDtoList[i] = {};
            }
          });
        }

        this.timeAndSessionIdDtoList = res.data.timeAndSessionIdDtoList? res.data.timeAndSessionIdDtoList: [];
        this.ruleForm.courseSessionIds = res.data.timeAndSessionIdDtoList? res.data.timeAndSessionIdDtoList: [];
        this.isUseEditSessionIds = res.data.timeAndSessionIdDtoList? res.data.timeAndSessionIdDtoList.map((e) => { return e.sessionId }): [];
        this.flag = res.data.flag;
        if (res.data.course) {
          this.ruleForm.checkList = res.data.course.map( (item) => item.courseId );
          if(this.signCoureCount == 1){
            this.ruleForm.checkList = this.ruleForm.checkList.join(',')
          }
        }
        this.ruleForm = Object.assign({}, this.ruleForm, {
          id: res.data.id,
          planId,
          realName: res.data.realName,
          cardType: res.data.cardType,
          cardNo: res.data.cardNo,
          sex: res.data.sex,
          phone: res.data.phone,
          email: res.data.email,
          schoolId: res.data.schoolId,
          stationId: res.data.station ? res.data.station.id : "",
          address: res.data.address,
          photo: res.data.photoUrl,
          placeId: res.data.place ? res.data.place.id : "",
        });

        // 2024年6月3日
        // if (res.data.station) {
        //   this.regionFiledList.push("stationId");
        // }

        res.data.extData.forEach((item) => {
          if (item.type == "provinceCity" && item.value) {
            this.ruleForm[item.name] = item.value.split(",");
            this.provinceCity.push(item.name);
          } else {
            this.ruleForm[item.name] = item.value;
          }
        });

        if (this.isUseTestSite) {
          this.getListTime();
          return getPlaceList({
            planId: this.planId,
            stationId: this.ruleForm.stationId,
          });
        }
        this.ruleForm.optionalExamDate = res.data.optionalExamDate
      }).then((res) => {
        if (res) {
          this.placeListInfo = res.data;
          if (res.data.length == 1) {
            this.ruleForm.placeId = res.data[0].placeId;
          }
        }
      });
    },

    isCanEdit(itemStr) {
      if (this.regionFiledList.length > 0) {
        return this.regionFiledList.includes(itemStr.charAt(0).toUpperCase() + itemStr.slice(1));
      } else {
        return false;
      }
    },

    setDataByCard() {
      let { cardNo } = this.ruleForm;
      let birthday = "";
      if (cardNo.length == 15) {
        birthday = "19" + cardNo.substr(6, 6);
      } else if (cardNo.length == 18) {
        birthday = cardNo.substr(6, 8);
      }
      birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
      this.ruleForm[this.birthday] = birthday;
      const num2 = parseInt(cardNo.substr(cardNo.length - 2, 1));
      const sex = num2 % 2 === 0 ? 0 : 1;
      this.$set(this.ruleForm, "sex", sex);
    },

    getCourse() {
      this.$api.applyManage
        .getPlanCourse({ planId: this.planId })
        .then((res) => {
          if (res.code && res.data.length > 0) {
            this.courseList = res.data;
            res.data.map((e) => {
              this.courseListConst.push(e.courseId);
            });
          }
        });
    },
    // 
    getConfigData() {
      this.$api.system.getConfigData().then((res) => {
        let stationName = "";
        res.data.configList.map((e) => {
          if (e.setName == "stationName") {
            stationName = e.setValue2;
          }
        });
        if (stationName) {
          this.isStationName = stationName + "：";
        } else {
          this.isStationName = "教学点：";
        }
        let configList = res.data.configList;
        let basicsMap = {};
        configList.forEach((item) => {
          basicsMap[item.setName] = item.setValue;
          if (item.setName == "stuImgCondition") {
            item.setShowText = item.setShowText ? item.setShowText : "1. 必须是报考人本人真实免冠照片，不许带眼镜，照片应清晰可识别身份，过于模糊的照片无法上报成功。";
            item.setValue2 = item.setValue2 ? item.setValue2 : "jpeg";
            item.setValue = item.setValue ? item.setValue : "2345";
            this.basicsMapImgRules = item;
          }
        });
        this.basicsMap = basicsMap.uploadTimes;
        this.basicsMaptext = this.basicsMap;
        this.basicsImageCheckFlag = basicsMap.imageCheck;
        this.smsCheckForSign = basicsMap.smsCheckForSign;
      });
    },

    upLoadSstate(fileData) {
      let loc = JSON.parse(localStorage.getItem("userInfo"));
      let formData = new FormData();
      formData.append("cardNo", this.ruleForm.cardNo);
      formData.append("file", fileData);
      formData.append("stuId", this.ruleForm.id);
      formData.append("stuName", this.ruleForm.realName);
      formData.append("type", this.ruleForm.cardType);
      formData.append("planId", this.getCurrentGlobalPlanId());
      this.$api.applyManage.savePhoto(formData).then((res) => {
      this.photoVerifyId = res.data.photoVerifyId;
        if (res.code == 0) {
          this.savePhotoError = res.error.msg;
        }
        let upNum = 0;
        let maxNum = 0;
        let url = "";
        if (res.error !== null) {
          upNum = res.error.upNum ? res.error.upNum : 0;
          maxNum = res.error.maxNum ? res.error.maxNum : 0;
          url = res.error.url;
          this.result = res.error.result === undefined ? "" : res.error.result;
        } else {
          upNum = res.data.upNum;
          maxNum = res.data.maxNum;
          this.result = res.data.result === undefined ? "" : res.data.result;
          url = res.data.url;
        }
        if (url) {
          this.url = url;
          this.ruleForm.photo = url;
        }
        this.upNum = upNum;
        this.upNums = maxNum - upNum;
      });
    },

    cancel() {
      this.$router.push({
        path: "/stuHome/home",
      });
    },

    initCountDown() {
      if (this.countDown <= 0) {
        clearTimeout(this.timer);
        return;
      }
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.countDown = this.countDown - 1;
      this.timer = setTimeout(this.initCountDown, 1000);
    },

    /**
     * @param { 图片格式/大小校验 }
     */
    beforeAvatarUpload(fileData) {
      let ImgRules = this.planInfo.photoFormat.split(",");
      let type = fileData.name.substring(fileData.name.lastIndexOf(".") + 1);
      const isJPG = ImgRules.indexOf(type) !== -1;
      const isLt30kb = fileData.size / 1024 < this.planInfo.photoSize;

      if (!isJPG && !isLt30kb) {
        this.$message.error(`该批次上传图片只能是 ${ this.planInfo.photoFormat } 格式，且大小不能超过${ this.planInfo.photoSize } kb! `);
      } else if (!isJPG) {
        this.$message.error(`该批次上传图片只能是 ${ this.planInfo.photoFormat } 格式!`);
      } else if (!isLt30kb) {
        this.$message.error(`该批次上传图片大小不能超过 ${ this.planInfo.photoSize } kb!`);
      }
      return isJPG && isLt30kb;
    },

    uploadImg(data) {
      let fileData = data.file;
      this.upLoadSstate(fileData);
    },
    async UpdateRegistrationFN(ruleForm) {
      this.submitBtnFlag = true; // 提交按钮禁用
      let checkParams = {
        userId: JSON.parse(window.localStorage.getItem("userInfo")).id,
        willPlanId: this.getCurrentGlobalPlanId()
      }
      //判断提交的批次是否和其他已报名批次有冲突
      const { code: checkCode } = await checkStudentSignPlanExclusiveAPI(checkParams);
      if (checkCode !== 1) {
        return false;
      }
      //下面是判断是否上传了必填材料对应的内容
      if (this.studentFileInfo.length > 0) {
        let studentFileInfoIds = this.studentFileInfo.filter(item => item.required == '1').map(item => item.id);
        let planFileSetIds = [];
        for(let i = 0; i < this.attachment_FileList.length; i++) {
          if(this.attachment_FileList[i] != undefined) {
            if(this.attachment_FileList[i].length > 0) {
              planFileSetIds.push(this.attachment_FileList[i][0].planFileSetId);
            }
          }
        }
        let TipId = [];
        for(let i = 0; i < studentFileInfoIds.length; i++) {
          if(planFileSetIds.indexOf(studentFileInfoIds[i]) == -1) {
            TipId.push(studentFileInfoIds[i]);
          }
        }
        let TipName = '';
        if(TipId.length > 0) {
          for(let i = 0; i < TipId.length; i++) {
            for(let j = 0; j < this.studentFileInfo.length; j++) {
              if(TipId[i] == this.studentFileInfo[j].id) {
                TipName += this.studentFileInfo[j].filename + '、';
              }
            }
          }
          TipName = TipName.substring(0, TipName.length - 1);
          this.$message.error(`请上传对应的 “${TipName}” 附件！`);
          this.submitBtnFlag = false;
          return;
        }
      }
      // if (this.studentFileInfo.length > 0) {
      //   if (this.studentFileInfo.length > this.attachment_FileList.length) {
      //     this.$message.error("请上传全部的 “报名材料” ！");
      //     this.submitBtnFlag = false;
      //     return false;
      //   }

      //   for (let i = 0;  i < this.attachment_FileList.length; i++) {
      //     if (this.attachment_FileList[i].length == 0) {
      //       this.$message.error("请上传全部的 “报名材料” ！");
      //       this.submitBtnFlag = false;
      //       return false;
      //     }
      //   }
      // }

      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          if(this.phoneAndEmailSet.isShowPhone && !this.phoneAndEmailSet.isMastPhone && this.ruleForm.phone){
            //如果显示手机号，但是手机号不是必填项，并且用户填写了手机号，则需要校验手机号是否是正确的格式
            const phoneReg = /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/
            if (!phoneReg.test(this.ruleForm.phone)) {
                this.$message.error('请输入正确的手机号');
                this.submitBtnFlag = false;
                return false
            }
          }
          if(this.phoneAndEmailSet.isShowEmail && !this.phoneAndEmailSet.isMastEmail && this.ruleForm.email){
            //如果显示邮箱，但是邮箱不是必填项，并且用户填写了邮箱，则需要校验邮箱是否是正确的格式
            const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
            if (!emailReg.test(this.ruleForm.email)) {
                this.$message.error('请输入正确的邮箱地址');
                this.submitBtnFlag = false;
                return false
            }
          }
          if (!this.ruleForm.photo) {
            this.$message({
              message: "请上传照片",
              type: "error",
            });
            this.submitBtnFlag = false;
            return;
          }
          if (!this.checkeds) {
            this.$message({
              message: "请勾选报名承诺信息",
              type: "error",
            });
            this.submitBtnFlag = false;
            return;
          }
          for (let key in this.ruleForm) {
            if (this.provinceCity.includes(key)) {
              this.ruleForm[key] = this.ruleForm[key].join(",");
            }
          }
          if (this.signCoureCount == 0) {
            this.ruleForm.checkList = Array.from(
              new Set(this.ruleForm.checkList)
            );
            var params = {
              ...this.ruleForm,
              courseId: this.ruleForm.checkList.join(","),
              planId: this.planId,
            };
          } else {
            if (Array.isArray(this.ruleForm.checkList)) {
              var params = {
                ...this.ruleForm,
                courseId: this.ruleForm.checkList.join(","),
                planId: this.planId,
              };
            } else {
              var params = {
                ...this.ruleForm,
                courseId: this.ruleForm.checkList,
                planId: this.planId,
              };
            }
          }

          params.photoVerifyId = this.photoVerifyId;
          params.smsCheckCode = this.phoneCode;


          if (this.exemptCourseId) {

            if (!this.exemptReasonId) {
              this.$message.error("您已勾选免考课程，请选择免考原因！");
              this.submitBtnFlag = false;
              return false;
            }

            if (this.ExemptFileList.length == 0) {
              this.$message.error("您已勾选免考课程，请上传免考证明材料！");
              this.submitBtnFlag = false;
              return false;
            }


            let exemptFileIds = [];
            this.ExemptFileList.map(e=>{
              exemptFileIds.push(e.id);
            })
            params.exemptCourseId = this.exemptCourseId
            params.exemptFileIds = exemptFileIds.join(",");
            params.exemptReasonId = this.exemptReasonId;
            params.reasonProveText = this.reasonProveText;
            params.exemptReasonName = this.exemptReasonName;
          }

          delete params.photo;
          delete params.checkList;
          let courseSessionIds = [];
          params.courseSessionIds.map((e) => {
            if (e.courseId && e.sessionId) {
              let par = {
                courseId: e.courseId,
                sessionId: e.sessionId,
              };
              courseSessionIds.push(par);
            }
          });

          if (this.needAudit == 0 && this.optionalExam == 1) {
            this.$confirm("是否确定选择" + this.ruleForm.optionalExamDate + "考试日期？若选择提交报名信息后不可修改。", "提示",
              {
                UpdateRegistration: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            ).then(async () => {
              this.params = params;
              if (this.smsCheckForSign === 1 && (this.phoneAndEmailSet.isShowPhone || this.phoneAndEmailSet.isShowEmail)) {
                this.phoneDialog = true;
                return;
              } else {
                const  data  = await UpdateRegistration(params);
                if(data.code == 1){
                  setTimeout(()=>{
                    this.$message.success("报名成功");
                    this.$router.push({
                      path: "/stuHome/stuExamine",
                    });
                  },1000)
                }else{
                  this.submitBtnFlag = false;
                }
              }
            });
          } else {
            if (this.isUseTestSite && courseSessionIds.length == 0) {
              this.$message.error("请选择要考试的科目&场次");
              this.submitBtnFlag = false;
              return false;
            } else {
              params.courseSessionIds = this.isUseTestSite ? JSON.stringify(courseSessionIds) : "";

              this.params = params;

              if (this.smsCheckForSign === 1) {
                this.phoneDialog = true;
                return;
              } else {
                UpdateRegistration(params).then((res) => {
                  if (res.code === 1) {
                    this.$message.success("报名成功");
                    this.$router.push({
                      path: "/stuHome/stuExamine",
                    });
                  } else {
                    this.submitBtnFlag = false;
                    this.ruleForm.courseSessionIds = [];
                  }
                }).catch((err) => {
                  this.ruleForm.courseSessionIds = [];
                  this.submitBtnFlag = false;
                });
              }
            }
          }
        } else {
          this.submitBtnFlag = false;
          this.$message({
            message: "请将表单填写完整！",
            type: "error",
          });
        }
      });
    },

    open() {
      this.$alert("", "系统提示", {
        confirmButtonText: "确定",
        callback: (action) => {
          this.$message({
            type: "info",
            message: `action: ${action}`,
          });
        },
      });
    },

    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    showUrl(url) {
      window.open(url);
    }
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-upload-list__item {
  min-width: 450px;
}
.ml8 {
  margin-left: 8px;
}
.mb16 {
  margin-bottom: 16px;
}

/deep/ .el-upload.el-upload--text {
  height: 36px;
  .default-upload-container {
    height: 36px;
    line-height: 36px;
  }
}

/* ** 课程场次样式 (默认) ** */
.examType {
  width: 316px;
  height: 32px;
  margin-right: 16px;
  margin-bottom: 16px;
  font-family: "Futura-Medium, Futura";
  
  /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background: #ebf5ff !important;
    border: 1px solid #006aff !important;
    color: #006aff !important;
    box-shadow: none;
  }

  /deep/ .el-radio-button__inner {
    width: 100%;
    height: 32px;
    padding: 0;
    text-align: center;
    line-height: 32px;
    color: #45494d;
    background-color: #f4f5f8;
    border-radius: 4px;
    border: 1px solid #dadde6;
  }
}

/* ** 课程场次样式 (选中) ** */
.examType.is-active {
  border-color: transparent;

  /deep/ .el-radio-button__inner {
    color: #006aff;
    background-color: #ebf5ff;
    border: 1px solid #006aff;
  }
}

/* ** 课程场次样式 (禁用) ** */
.examType.is-disabled {
  /deep/ .el-radio-button__inner {
    color: #c2c6cc;
    background-color: #f1f2f5;
    border: 1px solid #dadde6;
  }
}

.examType.is-disabled.is-active {
  /deep/ .el-radio-button__inner {
    color: #006aff !important;
    background-color: #f1f2f5 !important;
    border: 1px solid #006aff !important;
  }
}

// 展示大图样式
.showBigImg {
  /deep/ .el-dialog.el-dialog--center {
    border-radius: 8px;
  }

  /deep/ .el-dialog__body {
    display: flex;
    justify-content: center;

    img {
      width: auto;
      height: auto;
    }

    p {
      margin-top: 10px;
    }
  }
}

.address {
  width: 100%;

  /deep/ .el-form-item__content {
    width: calc(100% - 160px);
  }
}

.upload-img {
  display: flex;
  width: 360px;

  .photo {
    width: 116px;
    height: 152px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  /deep/ .el-form-item__content {
    display: flex;
  }
}

.avatarTipPhoto {
  display: flex;
  padding-top: 8px;
  vertical-align: top;
  line-height: 1.8;
}

/deep/ .el-form-item {
  margin-bottom: 30px;
}

/deep/ .el-form-item__content {
  line-height: 36px;
  min-width: 240px;
  max-width: calc(100% - 120px);
}

/deep/ .el-form-item__label {
  min-width: 120px;
  text-align: right;
  line-height: 36px;
}

/deep/ .el-radio-group {
  vertical-align: baseline;
}

.mainBox {
  background: #fff;
  border-radius: 8px;
  font-family: "PingFangSC-Medium, PingFang SC";
}

/* 大盒子,高度 100% -> auto */
.stuApply {
  background: #fff;
  width: 1240px;
  height: auto;
  border-radius: 8px;
  padding: 20px 24px 0 24px;
  box-sizing: border-box;

  .ots_header {
    width: 100%;
    height: 56px;
    font-size: 20px;
    font-weight: 600;
    color: #2d2f33;
    line-height: 56px;
    box-sizing: border-box;
    border-bottom: 1px solid #f1f2f5;
  }

  section {
    padding: 30px 32px 0 32px;
    border-bottom: 1px solid #f1f2f5;

    h4 {
      font-size: 16px;
      font-weight: 500;
      color: #2d2f33;
      margin-bottom: 30px;
    }
  }

  .title {
    width: 100%;
    height: 22px;
    font-size: 16px;
    font-weight: 500;
    color: #2d2f33;
    line-height: 22px;
    margin-top: 32px;
  }

  .header_nav {
    padding: 0 80px;
  }

  ul {
    width: 1420px;
    margin-left: 20px;

    li {
      margin-top: 32px;
      display: inline-block;
      font-size: 14px;
      width: 30%;

      em {
        color: #9299a6;
        display: inline-block;
        vertical-align: middle;
        width: 82px;
        text-align: right;
        font-style: normal;
        margin-right: 6px;
      }
    }
  }

  .input_add {
    width: 1420px;
    margin-top: 32px;
    margin-left: 20px;

    .el-form-item {
      width: 400px;
      margin-right: 30px;
    }
  }
}

.avatar-uploader /deep/ .avatar-uploader {
  width: 200px;
  height: 152px;
}

.avatar-uploader /deep/ .el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader /deep/ .el-upload:hover {
  border-color: #006aff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 116px;
  height: 152px;
  line-height: 152px;
  text-align: center;
  position: absolute;
  top: 0%;
  left: 0%;
}

.avatar-uploader /deep/ .el-upload:hover .avatar-uploader-icon {
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 3;
}

.center_img /deep/ .el-form-item__content {
  display: flex;
  line-height: 24px;
  float: right;
}

.avatarTips {
  width: 60%;
  padding-top: 8px;
  vertical-align: top;
  line-height: 1.8;
  margin-left: 15px;
}

.center_img /deep/ .avatarTip {
 
  padding-left: 16px;
  max-width: 800px;
}

.input_add /deep/ .el-form-item {
  width: 82px;
  text-align: right;
}

.ots_textarea {
  span {
    text-align: right;
    height: 20px;
    width: 80px;
    display: inline-block;
    vertical-align: top;
  }
}

.ots_textarea /deep/ .el-textarea {
  width: 800px;
  height: 100px;
  padding-left: 4px;
}

.agreement {
  width: 100%;
  margin-top: 30px;
  text-align: center;

  /deep/ .el-checkbox__label {
    color: #f27900;
  }
}

/deep/ .el-dialog__body {
  width: 880px;
  height: 440px;
  overflow: scroll;
  p {
    line-height: 30px;
    color: #45494d;
    padding: 0 40px;
    overflow: hidden;
  }
}

.border {
  width: 100%;
  height: 1px;
  background: #f1f2f5;
  margin: 10px auto;
}

.bordertitle {
  width: 100%;
  height: 1px;
  background: #f1f2f5;
  margin-top: 30px;
}

// /deep/ .el-checkbox-group {
//   float: right;
// }
.textcolor {
  color: #f27900;
}

img {
  width: 140px;
  height: 183px;
}

.col_grayQs {
  height: auto;
  font-size: 14px;
  font-weight: 500;
  color: #45494d;
  line-height: 24px;
}

.el-dialog__footer {
  width: 100%;
  height: 68px;
  text-align: center;
  box-shadow: 0px -8px 16px 0px rgba(0, 0, 0, 0.06);

  .el-button.el-button--primary {
    height: 36px;
    margin-top: 16px;
    border-radius: 20px;
  }
}

.img_style {
  width: 140px;
  height: 183px;

  img {
    width: 140px !important;
    height: 183px !important;
  }
}

.buttonClick {
  background-color: #2d2f33;
}

.el-button--primary.is-disabled:hover {
  background-color: #ccc;
}

/* 2021/11/26 IE 表单样式问题(盒模型大小同谷歌有异) */
/deep/ .el-input .el-input__inner {
  width: 240px;
  height: 36px;
  line-height: 18px;
}
/deep/ .el-input.fileWebsite .el-input__inner {
  width: 400px !important;
  height: 36px;
  line-height: 18px;
}

.realtime-page {
  width: 280px;
  height: 360px;
  margin-left: 38%;
}

.buttons {
  margin: 10px;
  height: 25px;
}

.textloding {
  width: 100%;
}

.inputCropper {
  opacity: 0;
  position: relative;
  left: 25%;
  top: 0;
  right: 0;
  bottom: 0;
}

.buttonmg {
  float: left;
  margin: 8px;
  img {
    width: 16px;
    height: 16px;
    margin-right: 8px;
  }
}

.flright {
  float: right;
  display: flex;
  width: 140px;
}

.el-dialog .auto-scroll {
  height: 600px;
}
.minsize {
  margin-bottom: 10px;
  cursor: pointer;
  width: 60px;
  border: 1px solid #f1f2f5;
  text-align: center;
  height: 25px;
  line-height: 25px;
}
.active {
  width: 60px;
  text-align: center;
  background: #ebf5ff;
  color: #006aff;
  height: 25px;
  line-height: 25px;
}
.maxSize {
  margin: 0px 0px 10px 10px;
  cursor: pointer;
  width: 60px;
  text-align: center;
  border: 1px solid #f1f2f5;
  height: 25px;
  line-height: 25px;
}
.yesbutton {
  margin-top: 20px;
  width: 150px;
  background-color: #006aff;
  color: #fff;
  margin-left: 10px;
}
.yesbuttonnone {
  margin-top: 20px;
  width: 150px;
  margin-left: 10px;
  color: #9299a6;
  background-color: #dadde6;
}
.imgbg {
  background: #e6e6e6;
}
/deep/.el-dialog.auto-scroll .el-dialog__body {
  max-height: 560px !important;
}
.titleimg {
  height: 450px;

  .clickbutton {
    margin-left: 22%;
    margin-top: 10%;
  }

  p {
    text-align: center;
    margin-top: 10px;
  }
}

.inputImgs {
  opacity: 0;
  position: relative;
  left: 36%;
  top: 0;
  right: 0;
  bottom: 0;
}
.p1-tis {
  margin-top: 10px;
}
.cropperimgwidth {
  p {
    text-align: left;
    padding: 10px 0 0px 0;
    margin-left: 20px;
  }
}
.original {
  width: 150px;
  height: 210px;
  padding: 10px;
}
.prompt_p {
  padding: 10px 0 !important;
}
.cropper-content {
  background: #dadde6;
}
.cropPicturewidth {
  width: 550px;
  margin: 0 auto;
}
.exampleimg {
  width: 100%;
  height: 100%;
}
.productiontitle {
  cursor: pointer;
}
.production {
  color: #006aff;
}
.pancelimg {
  position: absolute;
  top: 85%;
  left: 53%;
  opacity: 0;
  cursor: pointer;
  width: 150px;
  height: 40px;
}
.overflowimg {
  width: 100%;
  height: 50px;
  overflow: auto;
  overflow-x: auto;
  white-space: nowrap;
  margin-top: 10px !important;
  div {
    margin: 0 10px;
    display: inline-block;
    width: 70px !important;
    height: 39px !important;
    img {
      width: 70px !important;
      height: 39px !important;
    }
  }
}
.listimg {
  border: 2px solid #006aff;
}
.yesbuttonone {
  margin-top: 20px;
  width: 150px;
}
.prompticon {
  width: 18px !important;
  height: 18px !important;
  position: relative;
  top: 5px;
  right: 5px;
}
.advpancelimg {
  position: absolute;
  top: 84%;
  left: 19%;
  opacity: 0;
  height: 35px;
  width: 200px;
  cursor: pointer;
}
.choosclothes {
  font-size: 20px;
  font-weight: 500;
  color: #2d2f33;
  line-height: 44px;
}
.productiontitlecss {
  width: 600px;
}
.timeClass{
  /deep/.el-input {
    width: 300px;
   
  }
  /deep/.el-input__inner{
    width: 300px;
  }
}
</style>
